// import React, { useCallback, useEffect, useRef, useState } from "react";
// import { Chart, registerables } from "chart.js";
// import "../Style/Connectivity.css";

// const API_BASE_URL = "https://api.yellowmatrix.co.in";

// Chart.register(...registerables);

// function RaiseTicketPage({ onBack }) {
//   const [excelFile, setExcelFile] = useState(null);
//   const [isDragging, setIsDragging] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");

//   const token = localStorage.getItem("token");

//   const handleFile = (file) => {
//     setError("");
//     setSuccessMessage("");

//     if (!file) {
//       return;
//     }

//     const allowedExtensions = [".xlsx", ".xls"];
//     const fileName = file.name.toLowerCase();

//     const isValidFile = allowedExtensions.some((extension) =>
//       fileName.endsWith(extension),
//     );

//     if (!isValidFile) {
//       setError("Please upload only Excel files (.xlsx or .xls).");
//       return;
//     }

//     setExcelFile(file);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files?.[0];

//     handleFile(file);
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();

//     setIsDragging(false);

//     const file = event.dataTransfer.files?.[0];

//     handleFile(file);
//   };

//   const handleDragOver = (event) => {
//     event.preventDefault();

//     setIsDragging(true);
//   };

//   const handleDragLeave = (event) => {
//     event.preventDefault();

//     setIsDragging(false);
//   };

//   const removeFile = () => {
//     setExcelFile(null);
//     setError("");
//     setSuccessMessage("");

//     const fileInput = document.getElementById("ticket-excel-upload");

//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };

//   const handleSubmit = async () => {
//     setError("");
//     setSuccessMessage("");

//     if (!excelFile) {
//       setError("Please upload an Excel file.");
//       return;
//     }

//     if (!token) {
//       setError("Authentication token not found. Please login again.");
//       return;
//     }

//     setLoading(true);

//     try {
//       const formData = new FormData();

//       formData.append("file", excelFile);

//       const response = await fetch(`${API_BASE_URL}/raise-ticket`, {
//         method: "POST",

//         headers: {
//           Authorization: `Bearer ${token}`,
//         },

//         body: formData,
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         setError(
//           result.apiResponseMsg ||
//             result.error ||
//             result.message ||
//             "Failed to raise ticket.",
//         );

//         return;
//       }

//       setSuccessMessage(
//         result.apiResponseMsg ||
//           result.message ||
//           "Ticket raised successfully.",
//       );

//       setExcelFile(null);

//       const fileInput = document.getElementById("ticket-excel-upload");

//       if (fileInput) {
//         fileInput.value = "";
//       }
//     } catch (err) {
//       setError("Server error while raising ticket.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="ticket-wrapper-Connectivity">
//       <div className="ticket-page-Connectivity">
//         <div className="ticket-topbar-Connectivity">
//           <button
//             type="button"
//             className="cco-back-Connectivity"
//             onClick={onBack}
//           >
//             <i className="fas fa-arrow-left"></i>
//             Back to Connectivity
//           </button>

//           <h2>Raise Ticket Request</h2>
//         </div>

//         {error && (
//           <div className="ticket-error-Connectivity">
//             <i className="fas fa-exclamation-circle"></i>
//             {error}
//           </div>
//         )}

//         {successMessage && (
//           <div className="ticket-success-Connectivity">
//             <i className="fas fa-check-circle"></i>
//             {successMessage}
//           </div>
//         )}

//         <div className="ticket-section-Connectivity">
//           <h3 className="ticket-section-title-Connectivity">
//             <i className="fas fa-user"></i>
//             Customer Details
//           </h3>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               gap: "20px",
//             }}
//           >
//             <div className="ticket-field-Connectivity">
//               <label>Customer ID</label>

//               <input
//                 type="text"
//                 value="SENSE1343"
//                 readOnly
//                 className="ticket-readonly-input-Connectivity"
//               />
//             </div>

//             <div className="ticket-field-Connectivity">
//               <label>Request Type</label>
//               <input
//                 type="text"
//                 value="Whitelisting"
//                 readOnly
//                 className="ticket-readonly-input-Connectivity"
//               />
//             </div>
//           </div>
//         </div>

//         <div className="ticket-section-Connectivity">
//           <h3 className="ticket-section-title-Connectivity">
//             <i className="fas fa-file-excel"></i>
//             Upload Excel File
//           </h3>

//           <p className="ticket-upload-help-Connectivity">
//             Upload the Excel file containing the ticket details.
//           </p>

//           {!excelFile ? (
//             <div
//               className={`ticket-upload-box-Connectivity ${
//                 isDragging ? "ticket-upload-dragging-Connectivity" : ""
//               }`}
//               onDragOver={handleDragOver}
//               onDragLeave={handleDragLeave}
//               onDrop={handleDrop}
//             >
//               <div className="ticket-upload-icon-Connectivity">
//                 <i className="fas fa-cloud-upload-alt"></i>
//               </div>

//               <h4>Drag & Drop your Excel file here</h4>

//               <p>or</p>

//               <label
//                 htmlFor="ticket-excel-upload"
//                 className="ticket-browse-btn-Connectivity"
//               >
//                 <i className="fas fa-folder-open"></i>
//                 Browse File
//               </label>

//               <input
//                 id="ticket-excel-upload"
//                 type="file"
//                 accept=".xlsx,.xls"
//                 onChange={handleFileChange}
//                 hidden
//               />

//               <span className="ticket-file-format-Connectivity">
//                 Supported formats: .xlsx, .xls
//               </span>
//             </div>
//           ) : (
//             <div className="ticket-selected-file-Connectivity">
//               <div className="ticket-file-left-Connectivity">
//                 <div className="ticket-file-icon-Connectivity">
//                   <i className="fas fa-file-excel"></i>
//                 </div>

//                 <div className="ticket-file-info-Connectivity">
//                   <strong>{excelFile.name}</strong>

//                   <span>{(excelFile.size / 1024).toFixed(1)} KB</span>
//                 </div>
//               </div>

//               <button
//                 type="button"
//                 className="ticket-remove-file-Connectivity"
//                 onClick={removeFile}
//                 title="Remove file"
//               >
//                 <i className="fas fa-trash"></i>
//               </button>
//             </div>
//           )}
//         </div>

//         <div className="ticket-footer-Connectivity">
//           <button
//             type="button"
//             className="cco-cancel-Connectivity"
//             onClick={onBack}
//           >
//             Cancel
//           </button>

//           <button
//             type="button"
//             className="ticket-submit-btn-Connectivity"
//             onClick={handleSubmit}
//             disabled={!excelFile || loading}
//           >
//             {loading ? (
//               <>
//                 <i className="fas fa-spinner fa-spin"></i>
//                 Raising Ticket...
//               </>
//             ) : (
//               <>
//                 <i className="fas fa-ticket-alt"></i>
//                 Raise Ticket
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// function CCORegisterPage({ auth, onBack, simData }) {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [iccidDropdownOpen, setIccidDropdownOpen] = useState(false);
//   const [step, setStep] = useState("form");
//   const [allICCIDs, setAllICCIDs] = useState([]);

//   const [requestResult, setRequestResult] = useState({
//     iccids: [],
//     status: "",
//     success: false,
//     message: "",
//   });

//   const token = localStorage.getItem("token");

//   const getInitialForm = () => ({
//     action: "",
//     iccids: [],

//     deviceModel: "Yellow Matrix123",
//     deviceMake: "Yellow Matrix",
//     engineNo: "APPLIED FOR",
//     chassisNo: "APPLIED FOR",
//     vehicleRegNo: "APPLIED FOR",
//     ownerName: "Arpit kumar",
//     ownerMobile: "70XXXXXX59",
//     ownerAddress: "Sanket Vihar, Sai Nagar, Gahunje",
//     poiDocNo: "81XXXXXXXX04",
//     proofOfIdentityTypeStr: "Aadhar",
//     poaDocNo: "81XXXXXXXX04",
//     proofOfAddressTypeStr: "Aadhar",
//   });

//   const [form, setForm] = useState(getInitialForm());

//   const actions = [
//     "Commercial Activation",
//     "Suspension",
//     "Renewal",
//     "Top-Up",
//     "Mkyc-Update",
//   ];

//   const handleChange = (key, value) => {
//     setError("");

//     setForm((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const isCommercialActivation = form.action === "Commercial Activation";

//   const isTopUp = form.action === "Top-Up";

//   const isMkycUpdate = form.action === "Mkyc-Update";

//   const showMKYC = isCommercialActivation || isMkycUpdate || isTopUp;

//   const showICCIDSelector = true;

//   useEffect(() => {
//     const fetchAllICCIDs = async () => {
//       try {
//         const res = await fetch(`${API_BASE_URL}/get-all-iccids`, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         const result = await res.json();

//         if (!res.ok) {
//           throw new Error(result.error || "Failed to fetch ICCIDs.");
//         }

//         setAllICCIDs(result.iccids || []);
//       } catch (error) {
//         console.error("Error fetching ICCIDs:", error);

//         setError(error.message || "Failed to fetch ICCIDs.");
//       }
//     };

//     fetchAllICCIDs();
//   }, [token]);

//   const availableICCIDs = allICCIDs.filter(
//     (iccid) => !form.iccids.includes(String(iccid)),
//   );

//   const toggleICCID = (iccid) => {
//     const value = String(iccid);

//     setForm((prev) => {
//       const alreadySelected = prev.iccids.includes(value);

//       return {
//         ...prev,
//         iccids: alreadySelected
//           ? prev.iccids.filter((item) => item !== value)
//           : [...prev.iccids, value],
//       };
//     });

//     setError("");
//   };

//   const removeICCID = (iccid) => {
//     setForm((prev) => ({
//       ...prev,
//       iccids: prev.iccids.filter((item) => item !== iccid),
//     }));
//   };

//   const buildRequestBody = () => {
//     return {
//       action: form.action,
//       iccids: form.iccids,
//     };
//   };

//   const validateForm = () => {
//     if (!form.action) {
//       setError("Please select an action.");
//       return false;
//     }

//     if (form.iccids.length === 0) {
//       setError("Please select at least one ICCID.");
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async () => {
//     setError("");

//     if (!validateForm()) {
//       return;
//     }

//     setLoading(true);

//     try {
//       const requestBody = buildRequestBody();

//       console.log("CCO Request Body:", requestBody);

//       const res = await fetch(`${API_BASE_URL}/cco-requests`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(requestBody),
//       });

//       const result = await res.json();

//       if (!res.ok) {
//         const failureReason =
//           result.error ||
//           result.message ||
//           result.apiResponseMsg ||
//           "CCO Request failed.";

//         setForm(getInitialForm());

//         setRequestResult({
//           iccids: [],
//           status: "",
//           success: false,
//           message: failureReason,
//         });

//         setStep("status");

//         return;
//       }

//       setRequestResult({
//         iccids: [...form.iccids],
//         status: result.status || "Pending Approval",
//         success: true,
//         message: result.message || "CCO Request created successfully.",
//       });

//       setStep("status");
//     } catch (err) {
//       console.error(err);

//       setForm(getInitialForm());

//       setRequestResult({
//         iccids: [],
//         status: "",
//         success: false,
//         message: "Server error while creating CCO request.",
//       });

//       setStep("status");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (step === "status") {
//     return (
//       <div className="cco-wrapper-Connectivity">
//         <div className="cco-page-Connectivity">
//           <div className="cco-topbar-Connectivity">
//             <button className="cco-back-Connectivity" onClick={onBack}>
//               <i className="fas fa-arrow-left"></i> Back to Connectivity
//             </button>

//             <h2>CCO Request Status</h2>
//           </div>

//           <div className="cco-status-card-Connectivity">
//             {requestResult.success ? (
//               <>
//                 <div className="cco-status-icon-Connectivity success">
//                   <i className="fas fa-check-circle"></i>
//                 </div>

//                 <div className="cco-status-message-Connectivity success">
//                   CCO Request created successfully.
//                 </div>

//                 <div className="cco-status-info-Connectivity">
//                   <div className="cco-status-row-Connectivity">
//                     <span>Status</span>

//                     <strong className="pending-status-Connectivity">
//                       {requestResult.status || "Pending Approval"}
//                     </strong>
//                   </div>

//                   <div className="cco-status-row-Connectivity">
//                     <span>
//                       ICCID
//                       {requestResult.iccids.length > 1 ? "s" : ""}
//                     </span>

//                     <strong className="cco-status-iccid-Connectivity">
//                       {requestResult.iccids.map((iccid, index) => (
//                         <div key={`${iccid}-${index}`}>{iccid}</div>
//                       ))}
//                     </strong>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="cco-status-icon-Connectivity error">
//                   <i className="fas fa-times-circle"></i>
//                 </div>

//                 <div className="cco-status-message-Connectivity error">
//                   CCO Request failed
//                 </div>

//                 <div className="cco-error-reason-Connectivity">
//                   {requestResult.message}
//                 </div>
//               </>
//             )}

//             <button
//               className="cco-refresh-Connectivity"
//               onClick={() => {
//                 setForm(getInitialForm());

//                 setRequestResult({
//                   iccids: [],
//                   status: "",
//                   success: false,
//                   message: "",
//                 });

//                 setError("");
//                 setIccidDropdownOpen(false);
//                 setStep("form");
//               }}
//             >
//               <i className="fas fa-plus"></i> New CCO Request
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const sel = (key, label, options, required = false) => (
//     <div className="cco-field-Connectivity" key={key}>
//       <label>
//         {label}

//         {required && <span className="cco-required-Connectivity">*</span>}
//       </label>

//       <select
//         value={form[key]}
//         onChange={(e) => handleChange(key, e.target.value)}
//       >
//         <option value="">Select</option>

//         {options.map((option) => (
//           <option key={option} value={option}>
//             {option}
//           </option>
//         ))}
//       </select>
//     </div>
//   );

//   const readOnlyField = (key, label, type = "text") => (
//     <div className="cco-field-Connectivity" key={key}>
//       <label>
//         {label}

//         <span
//           style={{
//             marginLeft: "6px",
//             color: "#777",
//             fontSize: "11px",
//           }}
//           title="Static field"
//         >
//           <i className="fas fa-lock"></i>
//         </span>
//       </label>

//       <input
//         type={type}
//         value={form[key]}
//         readOnly
//         className="cco-readonly-field-Connectivity"
//       />
//     </div>
//   );

//   const readOnlySelect = (key, label) => (
//     <div className="cco-field-Connectivity" key={key}>
//       <label>
//         {label}

//         <span
//           style={{
//             marginLeft: "6px",
//             color: "#777",
//             fontSize: "11px",
//           }}
//           title="Static field"
//         >
//           <i className="fas fa-lock"></i>
//         </span>
//       </label>

//       <select
//         value={form[key]}
//         disabled
//         className="cco-readonly-field-Connectivity"
//       >
//         <option value={form[key]}>{form[key]}</option>
//       </select>
//     </div>
//   );

//   return (
//     <div className="cco-wrapper-Connectivity">
//       <div className="cco-page-Connectivity">
//         <div className="cco-topbar-Connectivity">
//           <button className="cco-back-Connectivity" onClick={onBack}>
//             <i className="fas fa-arrow-left"></i> Back to Connectivity
//           </button>

//           <h2>Create CCO Request</h2>
//         </div>

//         {error && (
//           <div className="cco-error-Connectivity">
//             <i className="fas fa-exclamation-circle"></i> {error}
//           </div>
//         )}

//         <div className="cco-section-Connectivity">
//           <h3 className="cco-section-title-Connectivity">
//             <i className="fas fa-cog"></i> General
//           </h3>

//           <div className="cco-fields-grid-Connectivity">
//             {sel("action", "Action", actions, true)}

//             {/* ICCID remains editable */}

//             {showICCIDSelector && (
//               <div className="cco-field-Connectivity">
//                 <label>
//                   ICCID
//                   <span className="cco-required-Connectivity">*</span>
//                 </label>

//                 <div className="cco-multi-select-Connectivity">
//                   <div
//                     className="cco-selected-box-Connectivity"
//                     onClick={() => setIccidDropdownOpen((prev) => !prev)}
//                   >
//                     {form.iccids.length === 0 ? (
//                       <span className="cco-placeholder-Connectivity">
//                         Select ICCID
//                       </span>
//                     ) : (
//                       <div className="cco-selected-items-Connectivity">
//                         {form.iccids.map((iccid) => (
//                           <span
//                             key={iccid}
//                             className="cco-selected-item-Connectivity"
//                           >
//                             {iccid}

//                             <button
//                               type="button"
//                               className="cco-remove-item-Connectivity"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 removeICCID(iccid);
//                               }}
//                             >
//                               ×
//                             </button>
//                           </span>
//                         ))}
//                       </div>
//                     )}

//                     <i
//                       className={`fas ${
//                         iccidDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"
//                       } cco-dropdown-icon-Connectivity`}
//                     ></i>
//                   </div>

//                   {iccidDropdownOpen && (
//                     <div className="cco-dropdown-menu-Connectivity">
//                       {availableICCIDs.length > 0 ? (
//                         availableICCIDs.map((iccid) => (
//                           <div
//                             key={iccid}
//                             className="cco-dropdown-option-Connectivity"
//                             onClick={() => toggleICCID(iccid)}
//                           >
//                             {iccid}
//                           </div>
//                         ))
//                       ) : (
//                         <div className="cco-no-options-Connectivity">
//                           All ICCIDs selected
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>

//         {showMKYC && (
//           <div className="cco-section-Connectivity">
//             <h3 className="cco-section-title-Connectivity">
//               <i className="fas fa-user-check"></i> MKYC Entity
//             </h3>

//             <div className="cco-fields-grid-Connectivity">
//               {readOnlyField("deviceModel", "Device Model")}

//               {readOnlyField("deviceMake", "Device Make")}

//               {readOnlyField("engineNo", "Engine Number")}

//               {readOnlyField("chassisNo", "Chassis Number")}

//               {readOnlyField("vehicleRegNo", "Vehicle Registration Number")}

//               {readOnlyField("ownerName", "Owner Name")}

//               {readOnlyField("ownerMobile", "Owner Mobile")}

//               {readOnlyField("ownerAddress", "Owner Address")}

//               {readOnlyField("poiDocNo", "POI Document Number")}

//               {readOnlySelect(
//                 "proofOfIdentityTypeStr",
//                 "Proof of Identity Type",
//               )}

//               {readOnlyField("poaDocNo", "POA Document Number")}

//               {readOnlySelect("proofOfAddressTypeStr", "Proof of Address Type")}
//             </div>
//           </div>
//         )}

//         <div className="cco-footer-Connectivity">
//           <button className="cco-cancel-Connectivity" onClick={onBack}>
//             Cancel
//           </button>

//           <button
//             className="cco-activate-Connectivity"
//             onClick={handleSubmit}
//             disabled={loading}
//           >
//             {loading ? (
//               <>
//                 <i className="fas fa-spinner fa-spin"></i> Creating...
//               </>
//             ) : (
//               <>
//                 <i className="fas fa-bolt"></i> Create CCO Request
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// const CCOApprovalPage = ({ onBack }) => {
//   const [requests, setRequests] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [rejectSuccessMessage, setRejectSuccessMessage] = useState("");
//   const [selectedRequests, setSelectedRequests] = useState([]);
//   const [expandedRequest, setExpandedRequest] = useState(null);
//   const [comment, setComment] = useState("");
//   const [actionFilter, setActionFilter] = useState("");
//   const [iccidFilter, setIccidFilter] = useState("");

//   const actionOptions = [
//     "Commercial Activation",
//     "Suspension",
//     "Renewal",
//     "Top-Up",
//     "Mkyc-Update",
//   ];

//   const [checklist, setChecklist] = useState({
//     commercialDetails: false,
//     customerSimDetails: false,
//     configurationDetails: false,
//   });

//   const token = localStorage.getItem("token");

//   const fetchPendingRequests = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const response = await fetch(`${API_BASE_URL}/cco-requests`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch CCO requests");
//       }

//       const data = await response.json();

//       const requestList = Array.isArray(data)
//         ? data
//         : Array.isArray(data.data)
//           ? data.data
//           : Array.isArray(data.requests)
//             ? data.requests
//             : [];

//       setRequests(requestList);
//     } catch (err) {
//       console.error("Error fetching CCO requests:", err);
//       setError(err.message || "Failed to load CCO requests");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchPendingRequests();
//   }, [fetchPendingRequests]);

//   const getRequestIccid = (request) => {
//     if (request.iccid) {
//       return request.iccid;
//     }

//     if (request.ICCID) {
//       return request.ICCID;
//     }

//     if (request.iccids) {
//       if (Array.isArray(request.iccids)) {
//         return request.iccids.join(", ");
//       }

//       return request.iccids;
//     }

//     if (request.ICCIDList) {
//       if (Array.isArray(request.ICCIDList)) {
//         return request.ICCIDList.join(", ");
//       }

//       return request.ICCIDList;
//     }

//     return "-";
//   };

//   const getRequestId = (request) => {
//     return (
//       request.requestId ||
//       request.request_id ||
//       request.id ||
//       request.RequestID ||
//       "-"
//     );
//   };

//   const getRequestAction = (request) => {
//     return String(
//       request.action || request.Action || request.requestAction || "",
//     ).trim();
//   };

//   const filteredRequests = requests.filter((request) => {
//     const requestAction = String(
//       request.action || request.Action || request.requestAction || "",
//     ).toLowerCase();

//     const requestIccid = String(getRequestIccid(request)).toLowerCase();

//     const selectedAction = actionFilter.toLowerCase();
//     const enteredIccid = iccidFilter.toLowerCase().trim();

//     const matchesAction = !selectedAction || requestAction === selectedAction;
//     const matchesIccid = !enteredIccid || requestIccid.includes(enteredIccid);

//     return matchesAction && matchesIccid;
//   });

//   const toggleRequest = (requestId) => {
//     setError("");
//     setSuccessMessage("");
//     setRejectSuccessMessage("");

//     const request = requests.find((item) => getRequestId(item) === requestId);

//     if (!request) return;

//     const requestAction = getRequestAction(request);

//     setSelectedRequests((prev) => {
//       if (prev.includes(requestId)) {
//         const updatedSelection = prev.filter((id) => id !== requestId);

//         if (updatedSelection.length === 0) {
//           setError("");
//         }

//         return updatedSelection;
//       }

//       if (prev.length === 0) {
//         setError("");
//         return [requestId];
//       }

//       const firstSelectedRequest = requests.find(
//         (item) => getRequestId(item) === prev[0],
//       );

//       const selectedAction = firstSelectedRequest
//         ? getRequestAction(firstSelectedRequest)
//         : "";

//       if (selectedAction !== requestAction) {
//         setError(
//           `You can only select requests with the same action. Selected action: ${selectedAction}`,
//         );

//         return prev;
//       }

//       setError("");

//       return [...prev, requestId];
//     });
//   };

//   const toggleDetails = (requestId) => {
//     setExpandedRequest((prev) => (prev === requestId ? null : requestId));
//   };

//   const toggleAll = () => {
//     const filteredIds = filteredRequests.map((request) =>
//       getRequestId(request),
//     );

//     const allSelected =
//       filteredIds.length > 0 &&
//       filteredIds.every((id) => selectedRequests.includes(id));

//     if (allSelected) {
//       setSelectedRequests((prev) =>
//         prev.filter((id) => !filteredIds.includes(id)),
//       );

//       setError("");
//       return;
//     }

//     if (selectedRequests.length > 0) {
//       const firstSelectedRequest = requests.find(
//         (request) => getRequestId(request) === selectedRequests[0],
//       );

//       const selectedAction = firstSelectedRequest
//         ? getRequestAction(firstSelectedRequest)
//         : "";

//       const sameActionIds = filteredRequests
//         .filter((request) => getRequestAction(request) === selectedAction)
//         .map((request) => getRequestId(request));

//       setSelectedRequests((prev) => [...new Set([...prev, ...sameActionIds])]);

//       setError("");
//       return;
//     }

//     const actions = [
//       ...new Set(filteredRequests.map((request) => getRequestAction(request))),
//     ];

//     if (actions.length > 1) {
//       setError(
//         "Select All cannot be used because the list contains different actions. Please select requests with the same action.",
//       );
//       return;
//     }

//     setSelectedRequests(filteredIds);
//     setError("");
//   };

//   const updateChecklist = (field) => {
//     setError("");
//     setSuccessMessage("");
//     setRejectSuccessMessage("");

//     setChecklist((prev) => ({
//       ...prev,
//       [field]: !prev[field],
//     }));
//   };

//   const allChecklistCompleted =
//     checklist.commercialDetails &&
//     checklist.customerSimDetails &&
//     checklist.configurationDetails;

//   const resetApprovalForm = () => {
//     setSelectedRequests([]);
//     setComment("");
//     setExpandedRequest(null);
//     setChecklist({
//       commercialDetails: false,
//       customerSimDetails: false,
//       configurationDetails: false,
//     });
//   };

//   const handleApprove = async () => {
//     setError("");
//     setSuccessMessage("");
//     setRejectSuccessMessage("");

//     if (selectedRequests.length === 0) {
//       setError("Please select at least one request.");
//       return;
//     }

//     if (!allChecklistCompleted) {
//       setError("Please complete all approval checklist items.");
//       return;
//     }

//     if (!comment.trim()) {
//       setError("Please enter a comment.");
//       return;
//     }

//     const approvedCount = selectedRequests.length;

//     try {
//       const response = await fetch(`${API_BASE_URL}/cco-requests/approve`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           requestIds: selectedRequests,
//           comment: comment.trim(),
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         setError(
//           result.error || result.message || "Failed to approve CCO requests.",
//         );
//         return;
//       }

//       setRequests((prev) =>
//         prev.filter(
//           (request) => !selectedRequests.includes(getRequestId(request)),
//         ),
//       );

//       resetApprovalForm();

//       if (result.sensoriseResponseCode === "SENSORISE_ERROR") {
//         setSuccessMessage(
//           `${approvedCount} request${
//             approvedCount !== 1 ? "s" : ""
//           } approved successfully, but Sensorise failed: ${
//             result.sensoriseResponseMsg || "Unknown error"
//           }`,
//         );
//       } else {
//         setSuccessMessage(
//           `${approvedCount} request${
//             approvedCount !== 1 ? "s" : ""
//           } approved successfully.${
//             result.sensoriseResponseMsg ? ` ${result.sensoriseResponseMsg}` : ""
//           }`,
//         );
//       }
//     } catch (err) {
//       console.error("Approve error:", err);
//       setError("Server error while approving CCO requests.");
//     }
//   };

//   const handleReject = async () => {
//     setError("");
//     setSuccessMessage("");
//     setRejectSuccessMessage("");

//     if (selectedRequests.length === 0) {
//       setError("Please select at least one request.");
//       return;
//     }

//     if (!allChecklistCompleted) {
//       setError("Please complete all approval checklist items.");
//       return;
//     }

//     if (!comment.trim()) {
//       setError("Please enter a comment.");
//       return;
//     }

//     const rejectedCount = selectedRequests.length;

//     try {
//       const response = await fetch(`${API_BASE_URL}/cco-requests/reject`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           requestIds: selectedRequests,
//           comment: comment.trim(),
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         setError(
//           result.error || result.message || "Failed to reject CCO requests.",
//         );
//         return;
//       }

//       setRequests((prev) =>
//         prev.filter(
//           (request) => !selectedRequests.includes(getRequestId(request)),
//         ),
//       );

//       resetApprovalForm();

//       setRejectSuccessMessage(
//         `${rejectedCount} request${
//           rejectedCount !== 1 ? "s" : ""
//         } rejected successfully.`,
//       );
//     } catch (err) {
//       console.error("Reject error:", err);
//       setRejectSuccessMessage("");
//       setError("Server error while rejecting CCO requests.");
//     }
//   };

//   const clearFilters = () => {
//     setActionFilter("");
//     setIccidFilter("");
//     setSuccessMessage("");
//     setRejectSuccessMessage("");
//     setError("");
//   };

//   return (
//     <div className="cco-approval-wrapper-Connectivity">
//       <div className="cco-approval-header-Connectivity">
//         <div>
//           <h1 className="cco-approval-title-Connectivity">
//             Review CCO Request
//           </h1>

//           <p className="cco-approval-subtitle-Connectivity">
//             verify the submitted information before approving the request.
//           </p>
//         </div>

//         <div className="cco-header-actions-Connectivity">
//           <button
//             type="button"
//             className="cco-btn-back-Connectivity"
//             onClick={onBack}
//           >
//             Back
//           </button>

//           <button
//             type="button"
//             className="cco-refresh-btn-Connectivity"
//             onClick={fetchPendingRequests}
//             disabled={loading}
//           >
//             {loading ? "Refreshing..." : "Refresh"}
//           </button>
//         </div>
//       </div>

//       <div className="cco-approval-main-card-Connectivity">
//         <div className="cco-filter-bar-Connectivity">
//           <div className="cco-filter-group-Connectivity">
//             <label className="cco-filter-label-Connectivity">Action</label>

//             <select
//               className="cco-filter-select-Connectivity"
//               value={actionFilter}
//               onChange={(e) => {
//                 setActionFilter(e.target.value);
//                 setSuccessMessage("");
//                 setRejectSuccessMessage("");
//                 setError("");
//               }}
//             >
//               <option value="">All Actions</option>

//               {actionOptions.map((action) => (
//                 <option key={action} value={action}>
//                   {action}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="cco-filter-group-Connectivity">
//             <label htmlFor="cco-iccid-filter">ICCID</label>

//             <input
//               id="cco-iccid-filter"
//               type="text"
//               value={iccidFilter}
//               onChange={(e) => {
//                 setIccidFilter(e.target.value);
//                 setSuccessMessage("");
//                 setRejectSuccessMessage("");
//                 setError("");
//               }}
//               placeholder="Search ICCID"
//               className="cco-filter-input-Connectivity"
//             />
//           </div>

//           <button
//             type="button"
//             className="cco-clear-filter-Connectivity"
//             onClick={clearFilters}
//           >
//             Clear Filters
//           </button>
//         </div>

//         {error && <div className="cco-error-message-Connectivity">{error}</div>}

//         {successMessage && (
//           <div className="cco-action-success-Connectivity">
//             <i className="fas fa-check-circle"></i>
//             {successMessage}
//           </div>
//         )}

//         {rejectSuccessMessage && (
//           <div className="cco-action-reject-success-Connectivity">
//             <i className="fas fa-times-circle"></i>
//             {rejectSuccessMessage}
//           </div>
//         )}

//         {loading ? (
//           <div className="cco-loading-Connectivity">
//             Loading pending CCO requests...
//           </div>
//         ) : requests.length === 0 ? (
//           <div className="cco-empty-Connectivity">
//             No pending CCO requests found.
//           </div>
//         ) : filteredRequests.length === 0 ? (
//           <div className="cco-no-filter-results-Connectivity">
//             No requests match the selected filters.
//           </div>
//         ) : (
//           <>
//             <div className="cco-request-header-row-Connectivity">
//               <div className="cco-request-column-Connectivity checkbox-column-Connectivity">
//                 <input
//                   type="checkbox"
//                   checked={
//                     filteredRequests.length > 0 &&
//                     filteredRequests.every((request) =>
//                       selectedRequests.includes(getRequestId(request)),
//                     )
//                   }
//                   onChange={toggleAll}
//                 />
//               </div>

//               <div className="cco-request-column-Connectivity">ICCID</div>
//               <div className="cco-request-column-Connectivity">BATCH ID</div>
//               <div className="cco-request-column-Connectivity">ACTION</div>
//               <div className="cco-request-column-Connectivity">CREATED BY</div>
//               <div className="cco-request-column-Connectivity">CREATED ON</div>

//               <div className="cco-request-column-Connectivity view-column-Connectivity">
//                 VIEW DETAILS
//               </div>
//             </div>

//             <div className="cco-pending-requests-Connectivity">
//               {filteredRequests.map((request, index) => {
//                 const requestId = getRequestId(request);
//                 const iccid = getRequestIccid(request);

//                 const batchId =
//                   request.batchId ||
//                   request.batch_id ||
//                   request.BatchID ||
//                   "N/A";

//                 const action =
//                   request.action ||
//                   request.Action ||
//                   request.requestAction ||
//                   "N/A";

//                 const createdBy =
//                   request.createdBy ||
//                   request.created_by ||
//                   request.CreatedBy ||
//                   request.username ||
//                   "N/A";

//                 const createdOn =
//                   request.createdOn ||
//                   request.created_at ||
//                   request.createdAt ||
//                   request.CreatedOn ||
//                   "N/A";

//                 return (
//                   <div
//                     key={`${requestId}-${index}`}
//                     className="cco-request-box-Connectivity"
//                   >
//                     <div className="cco-request-info-row-Connectivity">
//                       <div className="cco-request-info-item-Connectivity checkbox-column-Connectivity">
//                         <input
//                           type="checkbox"
//                           checked={selectedRequests.includes(requestId)}
//                           disabled={
//                             selectedRequests.length > 0 &&
//                             !selectedRequests.includes(requestId) &&
//                             getRequestAction(request) !==
//                               getRequestAction(
//                                 requests.find(
//                                   (item) =>
//                                     getRequestId(item) === selectedRequests[0],
//                                 ) || {},
//                               )
//                           }
//                           onChange={() => toggleRequest(requestId)}
//                         />
//                       </div>

//                       <div className="cco-request-info-item-Connectivity">
//                         <span>{iccid}</span>
//                       </div>

//                       <div className="cco-request-info-item-Connectivity">
//                         <span>{batchId}</span>
//                       </div>

//                       <div className="cco-request-info-item-Connectivity">
//                         <span>{action}</span>
//                       </div>

//                       <div className="cco-request-info-item-Connectivity">
//                         <span>{createdBy}</span>
//                       </div>

//                       <div className="cco-request-info-item-Connectivity">
//                         <span>{createdOn}</span>
//                       </div>

//                       <div className="cco-request-info-item-Connectivity view-column-Connectivity">
//                         <button
//                           type="button"
//                           className="cco-view-details-Connectivity"
//                           onClick={() => toggleDetails(requestId)}
//                         >
//                           {expandedRequest === requestId
//                             ? "Hide Details"
//                             : "View Details"}
//                         </button>
//                       </div>
//                     </div>

//                     {expandedRequest === requestId && (
//                       <div className="cco-request-details-wrapper-Connectivity">
//                         <div className="cco-review-section-card-Connectivity">
//                           <h3 className="cco-section-subheading-Connectivity">
//                             Request & Customer
//                           </h3>

//                           <div className="cco-review-grid-Connectivity">
//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>Request ID</span>
//                               <strong>{requestId}</strong>
//                             </div>

//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>Project Name</span>
//                               <strong>
//                                 {request.projectName ||
//                                   request.project_name ||
//                                   "N/A"}
//                               </strong>
//                             </div>

//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>Product Name</span>
//                               <strong>
//                                 {request.productName ||
//                                   request.product_name ||
//                                   "N/A"}
//                               </strong>
//                             </div>

//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>Customer ID</span>
//                               <strong>
//                                 {request.customerId ||
//                                   request.customer_id ||
//                                   request.CustomerID ||
//                                   "N/A"}
//                               </strong>
//                             </div>

//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>ICCID</span>
//                               <strong>{iccid}</strong>
//                             </div>

//                             <div className="cco-review-grid-item-Connectivity">
//                               <span>Request Date</span>
//                               <strong>
//                                 {request.requestDate ||
//                                   request.request_date ||
//                                   request.createdOn ||
//                                   request.created_at ||
//                                   "N/A"}
//                               </strong>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>

//             <div className="cco-common-review-card-Connectivity">
//               <h3 className="cco-common-section-title-Connectivity">
//                 <i className="fas fa-check-circle"></i>
//                 Approval Checklist
//               </h3>

//               <div className="cco-checklist-container-Connectivity">
//                 <label className="cco-checklist-item-Connectivity">
//                   <input
//                     type="checkbox"
//                     checked={checklist.commercialDetails}
//                     onChange={() => updateChecklist("commercialDetails")}
//                   />
//                   <span>Commercial details verified</span>
//                 </label>

//                 <label className="cco-checklist-item-Connectivity">
//                   <input
//                     type="checkbox"
//                     checked={checklist.customerSimDetails}
//                     onChange={() => updateChecklist("customerSimDetails")}
//                   />
//                   <span>Customer / SIM details verified</span>
//                 </label>

//                 <label className="cco-checklist-item-Connectivity">
//                   <input
//                     type="checkbox"
//                     checked={checklist.configurationDetails}
//                     onChange={() => updateChecklist("configurationDetails")}
//                   />
//                   <span>Configuration details verified</span>
//                 </label>
//               </div>
//             </div>

//             <div className="cco-common-review-card-Connectivity">
//               <h3 className="cco-common-section-title-Connectivity">Comment</h3>

//               <label className="cco-comment-label-Connectivity">
//                 Add your comment{" "}
//                 <span className="required-star-Connectivity">*</span>
//               </label>

//               <textarea
//                 value={comment}
//                 onChange={(e) => {
//                   setComment(e.target.value);
//                   setError("");
//                   setSuccessMessage("");
//                   setRejectSuccessMessage("");
//                 }}
//                 placeholder="Enter comment..."
//                 className="cco-comment-textarea-Connectivity"
//                 rows={4}
//               />
//             </div>

//             <div className="cco-common-footer-Connectivity">
//               <div className="cco-common-footer-left-Connectivity">
//                 <span>
//                   {selectedRequests.length} request
//                   {selectedRequests.length !== 1 ? "s" : ""} selected
//                 </span>
//               </div>

//               <div className="cco-common-footer-actions-Connectivity">
//                 <button
//                   type="button"
//                   className="cco-btn-approve-Connectivity"
//                   onClick={handleApprove}
//                 >
//                   Approve
//                 </button>

//                 <button
//                   type="button"
//                   className="cco-btn-reject-Connectivity"
//                   onClick={handleReject}
//                 >
//                   Reject
//                 </button>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// function ConnectivityDashboard() {
//   const simStatusChartRef = useRef(null);
//   const monthlyUsageChartRef = useRef(null);
//   const simStatusChartInstance = useRef(null);
//   const monthlyUsageChartInstance = useRef(null);

//   const [auth, setAuth] = useState(null);
//   const [page, setPage] = useState("dashboard");
//   const [simData, setSimData] = useState([]);
//   const [statusCount, setStatusCount] = useState({});
//   const [isConnecting, setIsConnecting] = useState(false);

//   const [totalIccidCount, setTotalIccidCount] = useState(() => {
//     const storedCount = localStorage.getItem("connectivity_total_iccid_count");

//     return storedCount !== null ? Number(storedCount) : 0;
//   });

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const [ccoStatusData, setCcoStatusData] = useState([]);
//   const [ccoStatusLoading, setCcoStatusLoading] = useState(false);
//   const [ccoStatusError, setCcoStatusError] = useState("");

//   const [ccoIccidModal, setCcoIccidModal] = useState(false);
//   const [selectedCcoSrId, setSelectedCcoSrId] = useState("");
//   const [selectedCcoIccids, setSelectedCcoIccids] = useState([]);

//   const [ccoStatusPage, setCcoStatusPage] = useState(1);
//   const [ccoStatusTotalPages, setCcoStatusTotalPages] = useState(1);
//   const [ccoStatusTotalRecords, setCcoStatusTotalRecords] = useState(0);

//   const [ccoDateRange, setCcoDateRange] = useState("today");
//   const [ccoStartDate, setCcoStartDate] = useState("");
//   const [ccoEndDate, setCcoEndDate] = useState("");

//   const [ticketStatusRequests, setTicketStatusRequests] = useState([]);
//   const [ticketStatusRequestsLoading, setTicketStatusRequestsLoading] =
//     useState(false);
//   const [ticketStatusRequestsError, setTicketStatusRequestsError] =
//     useState("");

//   const [ticketStatusPage, setTicketStatusPage] = useState(1);
//   const [ticketStatusTotalPages, setTicketStatusTotalPages] = useState(1);
//   const [ticketStatusTotalRecords, setTicketStatusTotalRecords] = useState(0);

//   const [ticketDateRange, setTicketDateRange] = useState("today");
//   const [ticketStartDate, setTicketStartDate] = useState("");
//   const [ticketEndDate, setTicketEndDate] = useState("");
//   const [ticketStatusModal, setTicketStatusModal] = useState(false);
//   const [ticketStatusLoading, setTicketStatusLoading] = useState(false);
//   const [ticketStatusData, setTicketStatusData] = useState(null);
//   const [ticketStatusError, setTicketStatusError] = useState("");

//   const token = localStorage.getItem("token");

//   const handleConnect = async (pageNumber = currentPage) => {
//     if (isConnecting) return;

//     setIsConnecting(true);

//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/get-sim-data?page=${pageNumber}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const result = await res.json();

//       if (!res.ok) {
//         throw new Error(result.error || "Failed to fetch SIM data.");
//       }

//       setSimData(result.simData || []);
//       setStatusCount(result.statusCount || {});

//       let dbIccidCount = 0;

//       if (result.pagination) {
//         dbIccidCount = Number(result.pagination.total || 0);
//       } else if (result.totalRecords !== undefined) {
//         dbIccidCount = Number(result.totalRecords || 0);
//       } else if (result.total !== undefined) {
//         dbIccidCount = Number(result.total || 0);
//       } else {
//         dbIccidCount = Number((result.simData || []).length);
//       }

//       setTotalIccidCount(dbIccidCount);

//       localStorage.setItem(
//         "connectivity_total_iccid_count",
//         String(dbIccidCount),
//       );

//       if (result.pagination) {
//         setCurrentPage(result.pagination.page || pageNumber);
//         setTotalPages(result.pagination.total_pages || 1);
//         setTotalRecords(result.pagination.total || 0);
//       } else {
//         setCurrentPage(pageNumber);
//         setTotalPages(1);
//         setTotalRecords(dbIccidCount);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setIsConnecting(false);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages && !isConnecting) {
//       handleConnect(currentPage + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1 && !isConnecting) {
//       handleConnect(currentPage - 1);
//     }
//   };

//   const handleViewCcoStatus = async (pageNumber = ccoStatusPage) => {
//     if (ccoStatusLoading) return;

//     if (ccoDateRange === "custom" && (!ccoStartDate || !ccoEndDate)) {
//       setCcoStatusError("Please select both start date and end date.");
//       return;
//     }

//     if (ccoDateRange === "custom" && ccoStartDate > ccoEndDate) {
//       setCcoStatusError("Start date cannot be greater than end date.");
//       return;
//     }

//     setCcoStatusLoading(true);
//     setCcoStatusError("");

//     try {
//       const response = await fetch(`${API_BASE_URL}/cco-requests/status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           selected: false,
//           srId: null,
//           page: pageNumber,
//           dateRange: ccoDateRange,
//           startDate: ccoDateRange === "custom" ? ccoStartDate : null,
//           endDate: ccoDateRange === "custom" ? ccoEndDate : null,
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.message || result.error || "Failed to fetch CCO status.",
//         );
//       }

//       if (result.success) {
//         setCcoStatusData(result.data || []);

//         if (result.pagination) {
//           setCcoStatusPage(result.pagination.page || pageNumber);
//           setCcoStatusTotalPages(result.pagination.total_pages || 1);
//           setCcoStatusTotalRecords(result.pagination.total || 0);
//         } else {
//           setCcoStatusPage(pageNumber);
//           setCcoStatusTotalPages(1);
//           setCcoStatusTotalRecords((result.data || []).length);
//         }
//       } else {
//         setCcoStatusData([]);
//         setCcoStatusPage(1);
//         setCcoStatusTotalPages(1);
//         setCcoStatusTotalRecords(0);
//         setCcoStatusError(result.message || "Failed to fetch CCO status.");
//       }
//     } catch (error) {
//       console.error("Error fetching CCO status:", error);

//       setCcoStatusError(error.message || "Failed to fetch CCO status.");

//       setCcoStatusData([]);
//       setCcoStatusPage(1);
//       setCcoStatusTotalPages(1);
//       setCcoStatusTotalRecords(0);
//     } finally {
//       setCcoStatusLoading(false);
//     }
//   };

//   const handleViewCcoIccids = (item) => {
//     setSelectedCcoSrId(item.srid || "");
//     setSelectedCcoIccids(item.iccids || []);
//     setCcoIccidModal(true);
//   };

//   const handleCloseCcoIccidModal = () => {
//     setCcoIccidModal(false);
//     setSelectedCcoSrId("");
//     setSelectedCcoIccids([]);
//   };

//   const handleCcoStatusNextPage = () => {
//     if (ccoStatusPage < ccoStatusTotalPages && !ccoStatusLoading) {
//       handleViewCcoStatus(ccoStatusPage + 1);
//     }
//   };

//   const handleCcoStatusPreviousPage = () => {
//     if (ccoStatusPage > 1 && !ccoStatusLoading) {
//       handleViewCcoStatus(ccoStatusPage - 1);
//     }
//   };

//   const handleCcoDateRangeChange = (value) => {
//     setCcoDateRange(value);
//     setCcoStatusPage(1);
//     setCcoStatusData([]);
//     setCcoStatusTotalPages(1);
//     setCcoStatusTotalRecords(0);
//     setCcoStatusError("");

//     if (value !== "custom") {
//       setCcoStartDate("");
//       setCcoEndDate("");
//     }
//   };

//   const handleViewTicketStatusRequests = async (
//     pageNumber = ticketStatusPage,
//   ) => {
//     if (ticketStatusRequestsLoading) return;

//     if (ticketDateRange === "custom" && (!ticketStartDate || !ticketEndDate)) {
//       setTicketStatusRequestsError(
//         "Please select both start date and end date.",
//       );
//       return;
//     }

//     if (ticketDateRange === "custom" && ticketStartDate > ticketEndDate) {
//       setTicketStatusRequestsError(
//         "Start date cannot be greater than end date.",
//       );
//       return;
//     }

//     setTicketStatusRequestsLoading(true);
//     setTicketStatusRequestsError("");

//     try {
//       const params = new URLSearchParams();

//       params.append("dateRange", ticketDateRange);
//       params.append("page", pageNumber);

//       if (ticketDateRange === "custom") {
//         params.append("startDate", ticketStartDate);
//         params.append("endDate", ticketEndDate);
//       }

//       const response = await fetch(
//         `${API_BASE_URL}/ticket-status-requests?${params.toString()}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.message || result.error || "Failed to fetch ticket requests.",
//         );
//       }

//       if (result.success) {
//         setTicketStatusRequests(result.data || []);

//         if (result.pagination) {
//           setTicketStatusPage(result.pagination.page || pageNumber);
//           setTicketStatusTotalPages(result.pagination.total_pages || 1);
//           setTicketStatusTotalRecords(result.pagination.total || 0);
//         } else {
//           setTicketStatusPage(pageNumber);
//           setTicketStatusTotalPages(1);
//           setTicketStatusTotalRecords((result.data || []).length);
//         }
//       } else {
//         setTicketStatusRequests([]);
//         setTicketStatusPage(1);
//         setTicketStatusTotalPages(1);
//         setTicketStatusTotalRecords(0);

//         setTicketStatusRequestsError(
//           result.message || "Failed to fetch ticket requests.",
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching ticket status requests:", error);

//       setTicketStatusRequestsError(
//         error.message || "Failed to fetch ticket requests.",
//       );

//       setTicketStatusRequests([]);
//       setTicketStatusPage(1);
//       setTicketStatusTotalPages(1);
//       setTicketStatusTotalRecords(0);
//     } finally {
//       setTicketStatusRequestsLoading(false);
//     }
//   };

//   const handleTicketStatusNextPage = () => {
//     if (
//       ticketStatusPage < ticketStatusTotalPages &&
//       !ticketStatusRequestsLoading
//     ) {
//       handleViewTicketStatusRequests(ticketStatusPage + 1);
//     }
//   };

//   const handleTicketStatusPreviousPage = () => {
//     if (ticketStatusPage > 1 && !ticketStatusRequestsLoading) {
//       handleViewTicketStatusRequests(ticketStatusPage - 1);
//     }
//   };

//   const handleTicketDateRangeChange = (value) => {
//     setTicketDateRange(value);
//     setTicketStatusPage(1);
//     setTicketStatusRequests([]);
//     setTicketStatusTotalPages(1);
//     setTicketStatusTotalRecords(0);
//     setTicketStatusRequestsError("");

//     if (value !== "custom") {
//       setTicketStartDate("");
//       setTicketEndDate("");
//     }
//   };

//   const handleViewTicketStatus = async (ticketNo) => {
//     if (ticketStatusLoading) return;

//     setTicketStatusModal(true);
//     setTicketStatusLoading(true);
//     setTicketStatusError("");
//     setTicketStatusData(null);

//     try {
//       const response = await fetch(`${API_BASE_URL}/ticket-status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           tokenId: ticketNo,
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.error || result.message || "Failed to fetch ticket status.",
//         );
//       }

//       if (result.success) {
//         setTicketStatusData(result.data || null);
//       } else {
//         setTicketStatusError(
//           result.error || result.message || "Failed to fetch ticket status.",
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching ticket status:", error);

//       setTicketStatusError(error.message || "Failed to fetch ticket status.");
//     } finally {
//       setTicketStatusLoading(false);
//     }
//   };

//   const handleCloseTicketStatus = () => {
//     setTicketStatusModal(false);
//     setTicketStatusData(null);
//     setTicketStatusError("");
//     setTicketStatusLoading(false);
//   };

//   const handleRegisterClick = () => {
//     setPage("register");
//   };

//   const handleBackToDashboard = () => {
//     setPage("dashboard");
//   };

//   const simStatusData = React.useMemo(
//     () => ({
//       labels: ["Active", "Inactive", "Expired", "Suspended","Other"],
//       counts: [
//         statusCount?.ACTIVE || 0,
//         statusCount?.INACTIVE || 0,
//         statusCount?.EXPIRED || 0,
//         statusCount?.SUSPEND || 0,
//         statusCount?.OTHER || 0,
//       ],
//       colors: ["#34D399", "#FBBF24", "#F87171", "#EF4444", "#7e4dee"],
//     }),
//     [statusCount],
//   );

//   const monthlyUsageChartData = React.useMemo(
//     () => ({
//       labels: [
//         "Jun 23",
//         "Jul 23",
//         "Aug 23",
//         "Sep 23",
//         "Oct 23",
//         "Nov 23",
//         "Dec 23",
//         "Jan 24",
//         "Feb 24",
//         "Mar 24",
//         "Apr 24",
//         "May 24",
//       ],
//       prepaid: [65, 70, 68, 72, 75, 80, 78, 85, 82, 88, 90, 85],
//       subscription: [40, 35, 42, 38, 30, 25, 30, 28, 35, 32, 28, 25],
//       paygo: [20, 25, 15, 20, 30, 25, 27, 22, 28, 20, 25, 20],
//     }),
//     [],
//   );

//   useEffect(() => {
//     if (page !== "dashboard") return;

//     if (!simStatusChartRef.current) return;

//     const ctx = simStatusChartRef.current.getContext("2d");

//     if (simStatusChartInstance.current) {
//       simStatusChartInstance.current.destroy();
//     }

//     simStatusChartInstance.current = new Chart(ctx, {
//       type: "doughnut",
//       data: {
//         labels: simStatusData.labels,
//         datasets: [
//           {
//             data: simStatusData.counts,
//             backgroundColor: simStatusData.colors,
//             borderColor: "white",
//             borderWidth: 2,
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         cutout: "70%",
//         plugins: {
//           legend: {
//             display: false,
//           },
//           datalabels: {
//             display: false,
//           },
//         },
//       },
//     });

//     return () => {
//       if (simStatusChartInstance.current) {
//         simStatusChartInstance.current.destroy();
//         simStatusChartInstance.current = null;
//       }
//     };
//   }, [page, simStatusData]);

//   useEffect(() => {
//     if (page !== "dashboard") return;

//     if (!monthlyUsageChartRef.current) return;

//     const ctx = monthlyUsageChartRef.current.getContext("2d");

//     if (monthlyUsageChartInstance.current) {
//       monthlyUsageChartInstance.current.destroy();
//     }

//     const maxUsage = Math.max(
//       ...monthlyUsageChartData.labels.map(
//         (_, i) =>
//           monthlyUsageChartData.prepaid[i] +
//           monthlyUsageChartData.subscription[i] +
//           monthlyUsageChartData.paygo[i],
//       ),
//     );

//     monthlyUsageChartInstance.current = new Chart(ctx, {
//       type: "bar",
//       data: {
//         labels: monthlyUsageChartData.labels.slice(-8),
//         datasets: [
//           {
//             label: "Prepaid",
//             data: monthlyUsageChartData.prepaid.slice(-8),
//             backgroundColor: "#60A5FA",
//             borderRadius: 4,
//           },
//           {
//             label: "Subscription",
//             data: monthlyUsageChartData.subscription.slice(-8),
//             backgroundColor: "#FBBF24",
//             borderRadius: 4,
//           },
//           {
//             label: "PAYGO",
//             data: monthlyUsageChartData.paygo.slice(-8),
//             backgroundColor: "#34D399",
//             borderRadius: 4,
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         scales: {
//           x: {
//             stacked: true,
//             grid: {
//               display: false,
//             },
//             ticks: {
//               color: "#6B7280",
//             },
//           },
//           y: {
//             stacked: true,
//             beginAtZero: true,
//             max: Math.ceil(maxUsage / 10) * 10,
//             ticks: {
//               color: "#6B7280",
//             },
//             grid: {
//               color: "#E5E7EB",
//             },
//           },
//         },
//         plugins: {
//           legend: {
//             position: "top",
//             labels: {
//               boxWidth: 12,
//               boxHeight: 12,
//               font: {
//                 size: 12,
//               },
//               color: "#374151",
//             },
//           },
//         },
//       },
//     });

//     return () => {
//       if (monthlyUsageChartInstance.current) {
//         monthlyUsageChartInstance.current.destroy();
//         monthlyUsageChartInstance.current = null;
//       }
//     };
//   }, [page, monthlyUsageChartData]);

//   if (page === "register") {
//     return (
//       <CCORegisterPage
//         auth={auth}
//         simData={simData}
//         onBack={handleBackToDashboard}
//       />
//     );
//   }

//   if (page === "approval") {
//     return <CCOApprovalPage onBack={handleBackToDashboard} />;
//   }

//   if (page === "ticket") {
//     return <RaiseTicketPage onBack={handleBackToDashboard} />;
//   }

//   return (
//     <>
//       <link
//         href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
//         rel="stylesheet"
//       />

//       <link
//         rel="stylesheet"
//         href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
//       />

//       <div className="session-bar-Connectivity">
//         <span>
//           <i className="fas fa-circle session-dot-Connectivity"></i> Connected
//           as <strong>{auth?.relationId || "User"}</strong>
//         </span>

//         <button
//           className="session-logout-Connectivity"
//           onClick={() => {
//             setAuth(null);
//             setPage("login");
//           }}
//         >
//           <i className="fas fa-sign-out-alt"></i> Disconnect
//         </button>
//       </div>

//       <div className="mainContainer-Connectivity">
//         <div className="tableContainer-Connectivity customShadow-Connectivity">
//           <div className="tableHeader-Connectivity">
//             <div className="tableHeaderActions-Connectivity">
//               <button
//                 className="buttonIcon-Connectivity connect-Button"
//                 onClick={() => {
//                   setCurrentPage(1);
//                   handleConnect(1);
//                 }}
//                 disabled={isConnecting}
//               >
//                 {isConnecting ? (
//                   <>
//                     <i
//                       className="fas fa-spinner fa-spin"
//                       style={{
//                         marginRight: "0.5rem",
//                       }}
//                     ></i>
//                     Connecting...
//                   </>
//                 ) : (
//                   <>
//                     Connect
//                     <i
//                       className="fas fa-plug"
//                       style={{
//                         marginLeft: "0.5rem",
//                       }}
//                     ></i>
//                   </>
//                 )}
//               </button>

//               <button
//                 className="buttonPrimary-Connectivity"
//                 onClick={handleRegisterClick}
//               >
//                 <i
//                   className="fas fa-plus"
//                   style={{
//                     marginRight: "0.5rem",
//                   }}
//                 ></i>
//                 Create CCO Request
//               </button>

//               <button
//                 className="buttonSecondary-Connectivity"
//                 onClick={() => setPage("ticket")}
//               >
//                 <i
//                   className="fas fa-ticket-alt"
//                   style={{
//                     marginRight: "0.5rem",
//                   }}
//                 ></i>
//                 Raise Ticket Request
//               </button>

//               <button
//                 className="buttonSecondary-Connectivity"
//                 onClick={() => setPage("approval")}
//               >
//                 <i
//                   className="fas fa-check-circle"
//                   style={{
//                     marginRight: "0.5rem",
//                   }}
//                 ></i>
//                 CCO Request Approve
//               </button>

//               <button className="buttonIcon-Connectivity">
//                 <i className="fas fa-cog"></i>
//               </button>
//             </div>
//           </div>

//           <div className="tableSearch-Connectivity">
//             <div className="tableSearch-Connectivity-i">
//               <div className="searchInput-Connectivity">
//                 <i className="fas fa-search searchIcon-Connectivity"></i>

//                 <input
//                   type="text"
//                   className="searchInputField-Connectivity"
//                   placeholder="Search by any attribute"
//                 />
//               </div>

//               <button className="buttonSecondary-Connectivity">
//                 Any
//                 <i
//                   className="fas fa-chevron-down"
//                   style={{
//                     marginLeft: "0.5rem",
//                     fontSize: "0.75rem",
//                   }}
//                 ></i>
//               </button>

//               <button className="buttonIcon-Connectivity">
//                 <i className="fas fa-search"></i>
//               </button>
//             </div>

//             <div className="tablePagination-Connectivity">
//               <div className="paginationInfo-Connectivity">
//                 {totalRecords === 0
//                   ? "Items 0-0"
//                   : `Items ${(currentPage - 1) * 5 + 1}-${Math.min(
//                       currentPage * 5,
//                       totalRecords,
//                     )} of ${totalRecords}`}
//               </div>

//               <div className="paginationControls-Connectivity">
//                 <button
//                   className="paginationButton-Connectivity"
//                   onClick={handlePreviousPage}
//                   disabled={currentPage === 1 || isConnecting}
//                 >
//                   Prev
//                 </button>

//                 <button
//                   className="paginationButton-Connectivity"
//                   onClick={handleNextPage}
//                   disabled={currentPage >= totalPages || isConnecting}
//                 >
//                   Next
//                 </button>

//                 <div className="paginationSelect-Connectivity">
//                   <select
//                     className="paginationSelectField-Connectivity"
//                     value="5"
//                     disabled
//                   >
//                     <option value="5">5</option>
//                   </select>

//                   <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div style={{ overflowX: "auto" }}>
//             <table className="table-Connectivity">
//               <thead className="tableHead-Connectivity">
//                 <tr>
//                   <th
//                     className="tableHeaderCell-Connectivity tableHeaderCellFirst-Connectivity"
//                     style={{
//                       width: "40px",
//                     }}
//                   >
//                     <input type="checkbox" className="checkbox-Connectivity" />
//                   </th>

//                   {[
//                     "ICCID",
//                     "IMEI",
//                     "VIN NUMBER",
//                     "VEHICLE ID",
//                     "CUSTOMER ID",
//                     "ORDER ID",
//                     "CARD STATE",
//                     "CARD STATUS",
//                     "ACTIVE PROFILES",
//                     "ACTIVATION DATE",
//                     "EXPIRY DATE",
//                     "DATA USAGE",
//                     "DATA USAGE DATE",
//                     "FALLBACK STATUS",
//                   ].map((h) => (
//                     <th key={h} className="tableHeaderCell-Connectivity">
//                       {h}

//                       <i
//                         className="fas fa-info-circle"
//                         style={{
//                           color: "#9ca3af",
//                           marginLeft: "0.25rem",
//                         }}
//                       ></i>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>

//               <tbody>
//                 {simData.map((sim, index) => (
//                   <tr
//                     key={sim.iccid || index}
//                     className="tableRow-Connectivity"
//                   >
//                     <td className="tableCell-Connectivity">
//                       <input
//                         type="checkbox"
//                         className="checkbox-Connectivity"
//                         defaultChecked={sim.isChecked}
//                       />
//                     </td>

//                     <td className="tableCell-Connectivity">{sim.iccid}</td>

//                     <td className="tableCell-Connectivity">{sim.imei}</td>

//                     <td className="tableCell-Connectivity">{sim.vin}</td>

//                     <td className="tableCell-Connectivity">{sim.vehicle_id}</td>

//                     <td className="tableCell-Connectivity">
//                       {sim.customer_id}
//                     </td>

//                     <td className="tableCell-Connectivity">{sim.orderId}</td>

//                     <td className="tableCell-Connectivity">{sim.cardState}</td>

//                     <td className="tableCell-Connectivity">
//                       {sim.primaryStatus}
//                     </td>

//                     <td className="tableCell-Connectivity">
//                       {sim.active_profiles}
//                     </td>

//                     <td className="tableCell-Connectivity">
//                       {sim.commercialActivationDate}
//                     </td>

//                     <td className="tableCell-Connectivity">
//                       {sim.commercialExpiryDate}
//                     </td>

//                     <td className="tableCell-Connectivity">{sim.dataUsage}</td>

//                     <td className="tableCell-Connectivity">
//                       {sim.dataUsageDate}
//                     </td>

//                     <td className="tableCell-Connectivity">
//                       {sim.fallBackStatus}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className="ccoStatusContainer-Connectivity">
//           <div className="ccoStatusHeader-Connectivity">
//             <div>
//               <h2 className="ccoStatusTitle-Connectivity">CCO Status</h2>

//               <p className="ccoStatusSubtitle-Connectivity">
//                 View status of approved CCO requests
//               </p>
//             </div>

//             <div className="ccoStatusActions-Connectivity">
//               <div className="ccoDateFilter-Connectivity">
//                 <select
//                   className="ccoDateSelect-Connectivity"
//                   value={ccoDateRange}
//                   onChange={(e) => handleCcoDateRangeChange(e.target.value)}
//                   disabled={ccoStatusLoading}
//                 >
//                   <option value="today">Today</option>
//                   <option value="yesterday">Yesterday</option>
//                   <option value="last_week">Last Week</option>
//                   <option value="custom">Custom</option>
//                 </select>

//                 <i className="fas fa-chevron-down ccoDateArrow-Connectivity"></i>
//               </div>

//               {ccoDateRange === "custom" && (
//                 <div className="ccoCustomDates-Connectivity">
//                   <input
//                     type="date"
//                     className="ccoDateInput-Connectivity"
//                     value={ccoStartDate}
//                     onChange={(e) => {
//                       setCcoStartDate(e.target.value);
//                       setCcoStatusPage(1);
//                       setCcoStatusError("");
//                     }}
//                     disabled={ccoStatusLoading}
//                   />

//                   <span className="ccoDateTo-Connectivity">to</span>

//                   <input
//                     type="date"
//                     className="ccoDateInput-Connectivity"
//                     value={ccoEndDate}
//                     onChange={(e) => {
//                       setCcoEndDate(e.target.value);
//                       setCcoStatusPage(1);
//                       setCcoStatusError("");
//                     }}
//                     disabled={ccoStatusLoading}
//                   />
//                 </div>
//               )}

//               <button
//                 className="ccoStatusViewButton-Connectivity"
//                 onClick={() => {
//                   setCcoStatusPage(1);
//                   handleViewCcoStatus(1);
//                 }}
//                 disabled={ccoStatusLoading}
//               >
//                 {ccoStatusLoading ? (
//                   <>
//                     <i className="fas fa-spinner fa-spin"></i>
//                     Loading...
//                   </>
//                 ) : (
//                   <>
//                     <i className="fas fa-eye"></i>
//                     View
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>

//           {ccoStatusError && (
//             <div className="ccoStatusError-Connectivity">
//               <i className="fas fa-exclamation-circle"></i>
//               {ccoStatusError}
//             </div>
//           )}

//           {ccoStatusLoading ? (
//             <div className="ccoStatusMessage-Connectivity">
//               <i className="fas fa-spinner fa-spin"></i>
//               <span>Loading CCO status...</span>
//             </div>
//           ) : ccoStatusData.length === 0 ? (
//             <div className="ccoStatusMessage-Connectivity">
//               <i className="fas fa-info-circle"></i>
//               <span>No CCO status available for the selected date range.</span>
//             </div>
//           ) : (
//             <>
//               <div className="ccoStatusTableWrapper-Connectivity">
//                 <table className="table-Connectivity ccoStatusTable-Connectivity">
//                   <thead className="tableHead-Connectivity">
//                     <tr>
//                       <th className="tableHeaderCell-Connectivity">SR ID</th>

//                       <th className="tableHeaderCell-Connectivity">ICCID</th>

//                       <th className="tableHeaderCell-Connectivity">ACTION</th>

//                       <th className="tableHeaderCell-Connectivity">STATUS</th>

//                       <th className="tableHeaderCell-Connectivity">
//                         APPROVED DATE
//                       </th>

//                       <th className="tableHeaderCell-Connectivity">
//                         APPROVED BY
//                       </th>

//                       <th className="tableHeaderCell-Connectivity">
//                         CARD COUNT
//                       </th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {ccoStatusData.map((item, index) => {
//                       const iccids = Array.isArray(item.iccids)
//                         ? item.iccids
//                         : [];

//                       return (
//                         <tr
//                           key={item.srid || index}
//                           className="tableRow-Connectivity"
//                         >
//                           <td className="tableCell-Connectivity ccoSrIdCell-Connectivity">
//                             {item.srid || "-"}
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             {iccids.length === 0 ? (
//                               "-"
//                             ) : iccids.length === 1 ? (
//                               iccids[0]
//                             ) : (
//                               <button
//                                 className="rowRegister-Connectivity"
//                                 onClick={() => handleViewCcoIccids(item)}
//                               >
//                                 <i
//                                   className="fas fa-eye"
//                                   style={{
//                                     marginRight: "0.35rem",
//                                   }}
//                                 ></i>
//                                 View All
//                               </button>
//                             )}
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             {item.actionRequested || "-"}
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             <span
//                               className={`ccoStatusBadge-Connectivity ${String(
//                                 item.srStatus || "",
//                               )
//                                 .toLowerCase()
//                                 .replace(/\s+/g, "-")}`}
//                             >
//                               {item.srStatus || "-"}
//                             </span>
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             {item.approvedDate || item.requestedDate || "-"}
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             {item.approvedBy || "-"}
//                           </td>

//                           <td className="tableCell-Connectivity">
//                             {item.cardCount ?? "-"}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="tablePagination-Connectivity">
//                 <div className="paginationInfo-Connectivity">
//                   {ccoStatusTotalRecords === 0
//                     ? "Items 0-0"
//                     : `Items ${(ccoStatusPage - 1) * 5 + 1}-${Math.min(
//                         ccoStatusPage * 5,
//                         ccoStatusTotalRecords,
//                       )} of ${ccoStatusTotalRecords}`}
//                 </div>

//                 <div className="paginationControls-Connectivity">
//                   <button
//                     className="paginationButton-Connectivity"
//                     onClick={handleCcoStatusPreviousPage}
//                     disabled={ccoStatusPage === 1 || ccoStatusLoading}
//                   >
//                     Prev
//                   </button>

//                   <button
//                     className="paginationButton-Connectivity"
//                     onClick={handleCcoStatusNextPage}
//                     disabled={
//                       ccoStatusPage >= ccoStatusTotalPages || ccoStatusLoading
//                     }
//                   >
//                     Next
//                   </button>

//                   <div className="paginationSelect-Connectivity">
//                     <select
//                       className="paginationSelectField-Connectivity"
//                       value="5"
//                       disabled
//                     >
//                       <option value="5">5</option>
//                     </select>

//                     <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="ccoStatusContainer-Connectivity">
//           <div className="ccoStatusHeader-Connectivity">
//             <div>
//               <h2 className="ccoStatusTitle-Connectivity">Ticket Status</h2>

//               <p className="ccoStatusSubtitle-Connectivity">
//                 View status of raised Sensorise tickets
//               </p>
//             </div>

//             <div className="ccoStatusActions-Connectivity">
//               <div className="ccoDateFilter-Connectivity">
//                 <select
//                   className="ccoDateSelect-Connectivity"
//                   value={ticketDateRange}
//                   onChange={(e) => handleTicketDateRangeChange(e.target.value)}
//                   disabled={ticketStatusRequestsLoading}
//                 >
//                   <option value="today">Today</option>
//                   <option value="yesterday">Yesterday</option>
//                   <option value="last_week">Last Week</option>
//                   <option value="custom">Custom</option>
//                 </select>

//                 <i className="fas fa-chevron-down ccoDateArrow-Connectivity"></i>
//               </div>

//               {ticketDateRange === "custom" && (
//                 <div className="ccoCustomDates-Connectivity">
//                   <input
//                     type="date"
//                     className="ccoDateInput-Connectivity"
//                     value={ticketStartDate}
//                     onChange={(e) => {
//                       setTicketStartDate(e.target.value);
//                       setTicketStatusPage(1);
//                       setTicketStatusRequestsError("");
//                     }}
//                     disabled={ticketStatusRequestsLoading}
//                   />

//                   <span className="ccoDateTo-Connectivity">to</span>

//                   <input
//                     type="date"
//                     className="ccoDateInput-Connectivity"
//                     value={ticketEndDate}
//                     onChange={(e) => {
//                       setTicketEndDate(e.target.value);
//                       setTicketStatusPage(1);
//                       setTicketStatusRequestsError("");
//                     }}
//                     disabled={ticketStatusRequestsLoading}
//                   />
//                 </div>
//               )}

//               <button
//                 className="ccoStatusViewButton-Connectivity"
//                 onClick={() => {
//                   setTicketStatusPage(1);
//                   handleViewTicketStatusRequests(1);
//                 }}
//                 disabled={ticketStatusRequestsLoading}
//               >
//                 {ticketStatusRequestsLoading ? (
//                   <>
//                     <i className="fas fa-spinner fa-spin"></i>
//                     Loading...
//                   </>
//                 ) : (
//                   <>
//                     <i className="fas fa-eye"></i>
//                     View
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>

//           {ticketStatusRequestsError && (
//             <div className="ccoStatusError-Connectivity">
//               <i className="fas fa-exclamation-circle"></i>
//               {ticketStatusRequestsError}
//             </div>
//           )}

//           {ticketStatusRequestsLoading ? (
//             <div className="ccoStatusMessage-Connectivity">
//               <i className="fas fa-spinner fa-spin"></i>
//               <span>Loading ticket requests...</span>
//             </div>
//           ) : ticketStatusRequests.length === 0 ? (
//             <div className="ccoStatusMessage-Connectivity">
//               <i className="fas fa-info-circle"></i>
//               <span>
//                 No ticket requests available for the selected date range.
//               </span>
//             </div>
//           ) : (
//             <>
//               <div className="ccoStatusTableWrapper-Connectivity">
//                 <table className="table-Connectivity ccoStatusTable-Connectivity">
//                   <thead className="tableHead-Connectivity">
//                     <tr>
//                       <th className="tableHeaderCell-Connectivity">
//                         TICKET NO
//                       </th>
//                       <th className="tableHeaderCell-Connectivity">
//                         FILE NAME
//                       </th>
//                       <th className="tableHeaderCell-Connectivity">
//                         RAISED BY
//                       </th>
//                       <th className="tableHeaderCell-Connectivity">
//                         RAISED AT
//                       </th>
//                       <th className="tableHeaderCell-Connectivity">ACTION</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {ticketStatusRequests.map((ticket, index) => (
//                       <tr
//                         key={ticket.id || ticket.ticketNo || index}
//                         className="tableRow-Connectivity"
//                       >
//                         <td className="tableCell-Connectivity">
//                           {ticket.ticketNo || "-"}
//                         </td>

//                         <td className="tableCell-Connectivity">
//                           {ticket.fileName || "-"}
//                         </td>

//                         <td className="tableCell-Connectivity">
//                           {ticket.raisedBy || "-"}
//                         </td>

//                         <td className="tableCell-Connectivity">
//                           {ticket.raisedAt
//                             ? new Date(ticket.raisedAt).toLocaleString(
//                                 "en-IN",
//                                 {
//                                   day: "2-digit",
//                                   month: "short",
//                                   year: "numeric",
//                                   hour: "2-digit",
//                                   minute: "2-digit",
//                                 },
//                               )
//                             : "-"}
//                         </td>

//                         <td className="tableCell-Connectivity">
//                           <button
//                             className="rowRegister-Connectivity"
//                             onClick={() =>
//                               handleViewTicketStatus(ticket.ticketNo)
//                             }
//                             disabled={ticketStatusLoading}
//                           >
//                             <i
//                               className="fas fa-eye"
//                               style={{
//                                 marginRight: "0.35rem",
//                               }}
//                             ></i>
//                             View
//                           </button>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="tablePagination-Connectivity">
//                 <div className="paginationInfo-Connectivity">
//                   {ticketStatusTotalRecords === 0
//                     ? "Items 0-0"
//                     : `Items ${(ticketStatusPage - 1) * 5 + 1}-${Math.min(
//                         ticketStatusPage * 5,
//                         ticketStatusTotalRecords,
//                       )} of ${ticketStatusTotalRecords}`}
//                 </div>

//                 <div className="paginationControls-Connectivity">
//                   <button
//                     className="paginationButton-Connectivity"
//                     onClick={handleTicketStatusPreviousPage}
//                     disabled={
//                       ticketStatusPage === 1 || ticketStatusRequestsLoading
//                     }
//                   >
//                     Prev
//                   </button>

//                   <button
//                     className="paginationButton-Connectivity"
//                     onClick={handleTicketStatusNextPage}
//                     disabled={
//                       ticketStatusPage >= ticketStatusTotalPages ||
//                       ticketStatusRequestsLoading
//                     }
//                   >
//                     Next
//                   </button>

//                   <div className="paginationSelect-Connectivity">
//                     <select
//                       className="paginationSelectField-Connectivity"
//                       value="5"
//                       disabled
//                     >
//                       <option value="5">5</option>
//                     </select>

//                     <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         <div className="connectivityChartsRow-Connectivity">
//           <div className="card-Connectivity connectivityChartCard-Connectivity">
//             <div className="connectivityChartHeader-Connectivity">
//               <div>
//                 <h2 className="simStatusTitle-Connectivity">SIM statuses</h2>

//                 <p className="connectivityChartSubtitle-Connectivity">
//                   Current SIM status distribution
//                 </p>
//               </div>

//               <div className="totalIccidBadge-Connectivity">
//                 <i className="fas fa-sim-card"></i>
//                 <span>{totalIccidCount.toLocaleString()}</span>
//                 <small>Total ICCIDs</small>
//               </div>
//             </div>

//             <div className="simStatusContent-Connectivity">
//               <div className="chartContainer-Connectivity simStatusChartWrapper-Connectivity">
//                 <canvas ref={simStatusChartRef}></canvas>

//                 <div className="simStatusCenterValue-Connectivity">
//                   <strong>{totalIccidCount.toLocaleString()}</strong>

//                   <span>Total ICCIDs</span>
//                 </div>
//               </div>

//               <div className="legendContainer-Connectivity">
//                 {simStatusData.labels.map((label, index) => (
//                   <div key={label} className="legendItem-Connectivity">
//                     <div
//                       className="legendColor-Connectivity"
//                       style={{
//                         backgroundColor: simStatusData.colors[index],
//                       }}
//                     ></div>

//                     <span>{label}</span>

//                     <span className="legendCount-Connectivity">
//                       {simStatusData.counts[index].toLocaleString()}
//                     </span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="card-Connectivity connectivityChartCard-Connectivity">
//             <div className="connectivityChartHeader-Connectivity">
//               <div>
//                 <h2 className="simStatusTitle-Connectivity">
//                   Monthly usage (MB)
//                 </h2>

//                 <p className="connectivityChartSubtitle-Connectivity">
//                   Monthly data usage by plan
//                 </p>
//               </div>
//             </div>

//             <div className="usageChartContainer-Connectivity">
//               <canvas ref={monthlyUsageChartRef}></canvas>
//             </div>
//           </div>
//         </div>
//       </div>

//       {ccoIccidModal && (
//         <div
//           className="ticketStatusOverlay-Connectivity"
//           onClick={handleCloseCcoIccidModal}
//         >
//           <div
//             className="ticketStatusModal-Connectivity"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="ticketStatusModalHeader-Connectivity">
//               <div>
//                 <h2 className="ticketStatusModalTitle-Connectivity">
//                   ICCID Details
//                 </h2>

//                 <p className="ticketStatusModalSubtitle-Connectivity">
//                   ICCIDs associated with SR ID {selectedCcoSrId || "-"}
//                 </p>
//               </div>

//               <button
//                 className="ticketStatusModalClose-Connectivity"
//                 onClick={handleCloseCcoIccidModal}
//               >
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>

//             <div className="ticketStatusDetails-Connectivity">
//               <div className="ticketStatusDetailGrid-Connectivity">
//                 <div className="ticketStatusDetailItem-Connectivity">
//                   <span className="ticketStatusDetailLabel-Connectivity">
//                     SR ID
//                   </span>

//                   <span className="ticketStatusDetailValue-Connectivity">
//                     {selectedCcoSrId || "-"}
//                   </span>
//                 </div>

//                 <div className="ticketStatusDetailItem-Connectivity">
//                   <span className="ticketStatusDetailLabel-Connectivity">
//                     ICCID Count
//                   </span>

//                   <span className="ticketStatusDetailValue-Connectivity">
//                     {selectedCcoIccids.length}
//                   </span>
//                 </div>
//               </div>

//               <div className="ticketStatusResponseBox-Connectivity">
//                 <span className="ticketStatusDetailLabel-Connectivity">
//                   ICCIDs
//                 </span>

//                 <div
//                   style={{
//                     marginTop: "0.75rem",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "0.5rem",
//                   }}
//                 >
//                   {selectedCcoIccids.length > 0 ? (
//                     selectedCcoIccids.map((iccid, index) => (
//                       <div
//                         key={`${iccid}-${index}`}
//                         style={{
//                           padding: "0.65rem 0.75rem",
//                           border: "1px solid #e5e7eb",
//                           borderRadius: "6px",
//                           backgroundColor: "#f9fafb",
//                           fontSize: "0.9rem",
//                           color: "#374151",
//                         }}
//                       >
//                         {iccid}
//                       </div>
//                     ))
//                   ) : (
//                     <p>-</p>
//                   )}
//                 </div>
//               </div>
//             </div>

//             <div className="ticketStatusModalFooter-Connectivity">
//               <button
//                 className="buttonSecondary-Connectivity"
//                 onClick={handleCloseCcoIccidModal}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {ticketStatusModal && (
//         <div
//           className="ticketStatusOverlay-Connectivity"
//           onClick={handleCloseTicketStatus}
//         >
//           <div
//             className="ticketStatusModal-Connectivity"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="ticketStatusModalHeader-Connectivity">
//               <div>
//                 <h2 className="ticketStatusModalTitle-Connectivity">
//                   Ticket Status Details
//                 </h2>

//                 <p className="ticketStatusModalSubtitle-Connectivity">
//                   Sensorise ticket information
//                 </p>
//               </div>

//               <button
//                 className="ticketStatusModalClose-Connectivity"
//                 onClick={handleCloseTicketStatus}
//               >
//                 <i className="fas fa-times"></i>
//               </button>
//             </div>

//             {ticketStatusLoading ? (
//               <div className="ticketStatusModalMessage-Connectivity">
//                 <i className="fas fa-spinner fa-spin"></i>
//                 <span>Fetching ticket status...</span>
//               </div>
//             ) : ticketStatusError ? (
//               <div className="ticketStatusModalError-Connectivity">
//                 <i className="fas fa-exclamation-circle"></i>
//                 <span>{ticketStatusError}</span>
//               </div>
//             ) : ticketStatusData ? (
//               <div className="ticketStatusDetails-Connectivity">
//                 <div className="ticketStatusDetailGrid-Connectivity">
//                   <div className="ticketStatusDetailItem-Connectivity">
//                     <span className="ticketStatusDetailLabel-Connectivity">
//                       Ticket No
//                     </span>

//                     <span className="ticketStatusDetailValue-Connectivity">
//                       {ticketStatusData.ticketNo || "-"}
//                     </span>
//                   </div>

//                   <div className="ticketStatusDetailItem-Connectivity">
//                     <span className="ticketStatusDetailLabel-Connectivity">
//                       Status
//                     </span>

//                     <span
//                       className={`ticketStatusBadge-Connectivity ${String(
//                         ticketStatusData.status || "",
//                       )
//                         .toLowerCase()
//                         .replace(/\s+/g, "-")}`}
//                     >
//                       {ticketStatusData.status || "-"}
//                     </span>
//                   </div>

//                   <div className="ticketStatusDetailItem-Connectivity">
//                     <span className="ticketStatusDetailLabel-Connectivity">
//                       Raised By
//                     </span>

//                     <span className="ticketStatusDetailValue-Connectivity">
//                       {ticketStatusData.raisedBy || "-"}
//                     </span>
//                   </div>

//                   <div className="ticketStatusDetailItem-Connectivity">
//                     <span className="ticketStatusDetailLabel-Connectivity">
//                       Raised At
//                     </span>

//                     <span className="ticketStatusDetailValue-Connectivity">
//                       {ticketStatusData.raisedAt
//                         ? new Date(ticketStatusData.raisedAt).toLocaleString(
//                             "en-IN",
//                             {
//                               day: "2-digit",
//                               month: "short",
//                               year: "numeric",
//                               hour: "2-digit",
//                               minute: "2-digit",
//                             },
//                           )
//                         : "-"}
//                     </span>
//                   </div>

//                   <div className="ticketStatusDetailItem-Connectivity">
//                     <span className="ticketStatusDetailLabel-Connectivity">
//                       Response Code
//                     </span>

//                     <span className="ticketStatusDetailValue-Connectivity">
//                       {ticketStatusData.apiResponseCode || "-"}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="ticketStatusResponseBox-Connectivity">
//                   <span className="ticketStatusDetailLabel-Connectivity">
//                     Response Message
//                   </span>

//                   <p>{ticketStatusData.apiResponseMsg || "-"}</p>
//                 </div>

//                 <div className="ticketStatusRemarkBox-Connectivity">
//                   <span className="ticketStatusDetailLabel-Connectivity">
//                     Remark
//                   </span>

//                   <p>{ticketStatusData.apiResponseRemark || "-"}</p>
//                 </div>
//               </div>
//             ) : (
//               <div className="ticketStatusModalMessage-Connectivity">
//                 <i className="fas fa-info-circle"></i>
//                 <span>No ticket status information available.</span>
//               </div>
//             )}

//             <div className="ticketStatusModalFooter-Connectivity">
//               <button
//                 className="buttonSecondary-Connectivity"
//                 onClick={handleCloseTicketStatus}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default ConnectivityDashboard;

import React, { useCallback, useEffect, useRef, useState } from "react";
import { Chart, registerables } from "chart.js";
import "../Style/Connectivity.css";

const API_BASE_URL = "https://api.yellowmatrix.co.in";

Chart.register(...registerables);

function RaiseTicketPage({ onBack }) {
  const [excelFile, setExcelFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const token = localStorage.getItem("token");
  const handleFile = (file) => {
    setError("");
    setSuccessMessage("");

    if (!file) {
      return;
    }

    const allowedExtensions = [".xlsx", ".xls"];
    const fileName = file.name.toLowerCase();

    const isValidFile = allowedExtensions.some((extension) =>
      fileName.endsWith(extension),
    );

    if (!isValidFile) {
      setError("Please upload only Excel files (.xlsx or .xls).");
      return;
    }

    setExcelFile(file);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    handleFile(file);
  };

  const handleDrop = (event) => {
    event.preventDefault();

    setIsDragging(false);

    const file = event.dataTransfer.files?.[0];

    handleFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();

    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();

    setIsDragging(false);
  };

  const removeFile = () => {
    setExcelFile(null);
    setError("");
    setSuccessMessage("");

    const fileInput = document.getElementById("ticket-excel-upload");

    if (fileInput) {
      fileInput.value = "";
    }
  };

  const handleSubmit = async () => {
    setError("");
    setSuccessMessage("");

    if (!excelFile) {
      setError("Please upload an Excel file.");
      return;
    }

    if (!token) {
      setError("Authentication token not found. Please login again.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await fetch(`${API_BASE_URL}/raise-ticket`, {
        method: "POST",

        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        setError(
          result.apiResponseMsg ||
            result.error ||
            result.message ||
            "Failed to raise ticket.",
        );

        return;
      }

      setSuccessMessage(
        result.apiResponseMsg ||
          result.message ||
          "Ticket raised successfully.",
      );

      setExcelFile(null);

      const fileInput = document.getElementById("ticket-excel-upload");

      if (fileInput) {
        fileInput.value = "";
      }
    } catch (err) {
      setError("Server error while raising ticket.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ticket-wrapper-Connectivity">
      <div className="ticket-page-Connectivity">
        <div className="ticket-topbar-Connectivity">
          <button
            type="button"
            className="cco-back-Connectivity"
            onClick={onBack}
          >
            <i className="fas fa-arrow-left"></i>
            Back to Connectivity
          </button>

          <h2>Raise Ticket Request</h2>
        </div>

        {error && (
          <div className="ticket-error-Connectivity">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}

        {successMessage && (
          <div className="ticket-success-Connectivity">
            <i className="fas fa-check-circle"></i>
            {successMessage}
          </div>
        )}
        <div className="ticket-section-Connectivity">
          <h3 className="ticket-section-title-Connectivity">
            <i className="fas fa-user"></i>
            Customer Details
          </h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "20px",
            }}
          >
            <div className="ticket-field-Connectivity">
              <label>Customer ID</label>

              <input
                type="text"
                value="SENSE1343"
                readOnly
                className="ticket-readonly-input-Connectivity"
              />
            </div>

            <div className="ticket-field-Connectivity">
              <label>Request Type</label>
              <input
                type="text"
                value="Whitelisting"
                readOnly
                className="ticket-readonly-input-Connectivity"
              />
            </div>
          </div>
        </div>

        <div className="ticket-section-Connectivity">
          <h3 className="ticket-section-title-Connectivity">
            <i className="fas fa-file-excel"></i>
            Upload Excel File
          </h3>

          <p className="ticket-upload-help-Connectivity">
            Upload the Excel file containing the ticket details.
          </p>

          {!excelFile ? (
            <div
              className={`ticket-upload-box-Connectivity ${
                isDragging ? "ticket-upload-dragging-Connectivity" : ""
              }`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div className="ticket-upload-icon-Connectivity">
                <i className="fas fa-cloud-upload-alt"></i>
              </div>

              <h4>Drag & Drop your Excel file here</h4>

              <p>or</p>

              <label
                htmlFor="ticket-excel-upload"
                className="ticket-browse-btn-Connectivity"
              >
                <i className="fas fa-folder-open"></i>
                Browse File
              </label>

              <input
                id="ticket-excel-upload"
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                hidden
              />

              <span className="ticket-file-format-Connectivity">
                Supported formats: .xlsx, .xls
              </span>
            </div>
          ) : (
            <div className="ticket-selected-file-Connectivity">
              <div className="ticket-file-left-Connectivity">
                <div className="ticket-file-icon-Connectivity">
                  <i className="fas fa-file-excel"></i>
                </div>

                <div className="ticket-file-info-Connectivity">
                  <strong>{excelFile.name}</strong>

                  <span>{(excelFile.size / 1024).toFixed(1)} KB</span>
                </div>
              </div>

              <button
                type="button"
                className="ticket-remove-file-Connectivity"
                onClick={removeFile}
                title="Remove file"
              >
                <i className="fas fa-trash"></i>
              </button>
            </div>
          )}
        </div>

        <div className="ticket-footer-Connectivity">
          <button
            type="button"
            className="cco-cancel-Connectivity"
            onClick={onBack}
          >
            Cancel
          </button>

          <button
            type="button"
            className="ticket-submit-btn-Connectivity"
            onClick={handleSubmit}
            disabled={!excelFile || loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Raising Ticket...
              </>
            ) : (
              <>
                <i className="fas fa-ticket-alt"></i>
                Raise Ticket
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

function CCORegisterPage({ auth, onBack, simData }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [iccidDropdownOpen, setIccidDropdownOpen] = useState(false);
  const [step, setStep] = useState("form");
  const [allICCIDs, setAllICCIDs] = useState([]);

  const [requestResult, setRequestResult] = useState({
    iccids: [],
    status: "",
    success: false,
    message: "",
  });

  const token = localStorage.getItem("token");

  const getInitialForm = () => ({
    action: "",
    iccids: [],

    deviceModel: "Yellow Matrix123",
    deviceMake: "Yellow Matrix",
    engineNo: "APPLIED FOR",
    chassisNo: "APPLIED FOR",
    vehicleRegNo: "APPLIED FOR",
    ownerName: "Arpit kumar",
    ownerMobile: "70XXXXXX59",
    ownerAddress: "Sanket Vihar, Sai Nagar, Gahunje",
    poiDocNo: "81XXXXXXXX04",
    proofOfIdentityTypeStr: "Aadhar",
    poaDocNo: "81XXXXXXXX04",
    proofOfAddressTypeStr: "Aadhar",
  });

  const [form, setForm] = useState(getInitialForm());

  const actions = [
    "Commercial Activation",
    "Suspension",
    "Renewal",
    "Top-Up",
    "Mkyc-Update",
  ];

  const handleChange = (key, value) => {
    setError("");

    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const isCommercialActivation = form.action === "Commercial Activation";

  const isTopUp = form.action === "Top-Up";

  const isMkycUpdate = form.action === "Mkyc-Update";

  const showMKYC = isCommercialActivation || isMkycUpdate || isTopUp;
  const showICCIDSelector = true;

  useEffect(() => {
    const fetchAllICCIDs = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/get-all-iccids`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await res.json();

        if (!res.ok) {
          throw new Error(result.error || "Failed to fetch ICCIDs.");
        }

        setAllICCIDs(result.iccids || []);
      } catch (error) {
        console.error("Error fetching ICCIDs:", error);

        setError(error.message || "Failed to fetch ICCIDs.");
      }
    };

    fetchAllICCIDs();
  }, [token]);

  const availableICCIDs = allICCIDs.filter(
    (iccid) => !form.iccids.includes(String(iccid)),
  );

  const toggleICCID = (iccid) => {
    const value = String(iccid);

    setForm((prev) => {
      const alreadySelected = prev.iccids.includes(value);

      return {
        ...prev,
        iccids: alreadySelected
          ? prev.iccids.filter((item) => item !== value)
          : [...prev.iccids, value],
      };
    });

    setError("");
  };

  const removeICCID = (iccid) => {
    setForm((prev) => ({
      ...prev,
      iccids: prev.iccids.filter((item) => item !== iccid),
    }));
  };

  const buildRequestBody = () => {
    return {
      action: form.action,
      iccids: form.iccids,
    };
  };

  const validateForm = () => {
    if (!form.action) {
      setError("Please select an action.");
      return false;
    }

    if (form.iccids.length === 0) {
      setError("Please select at least one ICCID.");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    setError("");

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const requestBody = buildRequestBody();

      console.log("CCO Request Body:", requestBody);

      const res = await fetch(`${API_BASE_URL}/cco-requests`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      const result = await res.json();

      if (!res.ok) {
        const failureReason =
          result.error ||
          result.message ||
          result.apiResponseMsg ||
          "CCO Request failed.";

        setForm(getInitialForm());

        setRequestResult({
          iccids: [],
          status: "",
          success: false,
          message: failureReason,
        });

        setStep("status");

        return;
      }

      setRequestResult({
        iccids: [...form.iccids],
        status: result.status || "Pending Approval",
        success: true,
        message: result.message || "CCO Request created successfully.",
      });

      setStep("status");
    } catch (err) {
      console.error(err);

      setForm(getInitialForm());

      setRequestResult({
        iccids: [],
        status: "",
        success: false,
        message: "Server error while creating CCO request.",
      });

      setStep("status");
    } finally {
      setLoading(false);
    }
  };

  if (step === "status") {
    return (
      <div className="cco-wrapper-Connectivity">
        <div className="cco-page-Connectivity">
          <div className="cco-topbar-Connectivity">
            <button className="cco-back-Connectivity" onClick={onBack}>
              <i className="fas fa-arrow-left"></i> Back to Connectivity
            </button>

            <h2>CCO Request Status</h2>
          </div>

          <div className="cco-status-card-Connectivity">
            {requestResult.success ? (
              <>
                <div className="cco-status-icon-Connectivity success">
                  <i className="fas fa-check-circle"></i>
                </div>

                <div className="cco-status-message-Connectivity success">
                  CCO Request created successfully.
                </div>

                <div className="cco-status-info-Connectivity">
                  <div className="cco-status-row-Connectivity">
                    <span>Status</span>

                    <strong className="pending-status-Connectivity">
                      {requestResult.status || "Pending Approval"}
                    </strong>
                  </div>

                  <div className="cco-status-row-Connectivity">
                    <span>
                      ICCID
                      {requestResult.iccids.length > 1 ? "s" : ""}
                    </span>

                    <strong className="cco-status-iccid-Connectivity">
                      {requestResult.iccids.map((iccid, index) => (
                        <div key={`${iccid}-${index}`}>{iccid}</div>
                      ))}
                    </strong>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="cco-status-icon-Connectivity error">
                  <i className="fas fa-times-circle"></i>
                </div>

                <div className="cco-status-message-Connectivity error">
                  CCO Request failed
                </div>

                <div className="cco-error-reason-Connectivity">
                  {requestResult.message}
                </div>
              </>
            )}

            <button
              className="cco-refresh-Connectivity"
              onClick={() => {
                setForm(getInitialForm());

                setRequestResult({
                  iccids: [],
                  status: "",
                  success: false,
                  message: "",
                });

                setError("");
                setIccidDropdownOpen(false);
                setStep("form");
              }}
            >
              <i className="fas fa-plus"></i> New CCO Request
            </button>
          </div>
        </div>
      </div>
    );
  }

  const sel = (key, label, options, required = false) => (
    <div className="cco-field-Connectivity" key={key}>
      <label>
        {label}

        {required && <span className="cco-required-Connectivity">*</span>}
      </label>

      <select
        value={form[key]}
        onChange={(e) => handleChange(key, e.target.value)}
      >
        <option value="">Select</option>

        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );

  const readOnlyField = (key, label, type = "text") => (
    <div className="cco-field-Connectivity" key={key}>
      <label>
        {label}

        <span
          style={{
            marginLeft: "6px",
            color: "#777",
            fontSize: "11px",
          }}
          title="Static field"
        >
          <i className="fas fa-lock"></i>
        </span>
      </label>

      <input
        type={type}
        value={form[key]}
        readOnly
        className="cco-readonly-field-Connectivity"
      />
    </div>
  );

  const readOnlySelect = (key, label) => (
    <div className="cco-field-Connectivity" key={key}>
      <label>
        {label}

        <span
          style={{
            marginLeft: "6px",
            color: "#777",
            fontSize: "11px",
          }}
          title="Static field"
        >
          <i className="fas fa-lock"></i>
        </span>
      </label>

      <select
        value={form[key]}
        disabled
        className="cco-readonly-field-Connectivity"
      >
        <option value={form[key]}>{form[key]}</option>
      </select>
    </div>
  );

  return (
    <div className="cco-wrapper-Connectivity">
      <div className="cco-page-Connectivity">
        <div className="cco-topbar-Connectivity">
          <button className="cco-back-Connectivity" onClick={onBack}>
            <i className="fas fa-arrow-left"></i> Back to Connectivity
          </button>

          <h2>Create CCO Request</h2>
        </div>

        {error && (
          <div className="cco-error-Connectivity">
            <i className="fas fa-exclamation-circle"></i> {error}
          </div>
        )}

        <div className="cco-section-Connectivity">
          <h3 className="cco-section-title-Connectivity">
            <i className="fas fa-cog"></i> General
          </h3>

          <div className="cco-fields-grid-Connectivity">
            {sel("action", "Action", actions, true)}

            {/* ICCID remains editable */}

            {showICCIDSelector && (
              <div className="cco-field-Connectivity">
                <label>
                  ICCID
                  <span className="cco-required-Connectivity">*</span>
                </label>

                <div className="cco-multi-select-Connectivity">
                  <div
                    className="cco-selected-box-Connectivity"
                    onClick={() => setIccidDropdownOpen((prev) => !prev)}
                  >
                    {form.iccids.length === 0 ? (
                      <span className="cco-placeholder-Connectivity">
                        Select ICCID
                      </span>
                    ) : (
                      <div className="cco-selected-items-Connectivity">
                        {form.iccids.map((iccid) => (
                          <span
                            key={iccid}
                            className="cco-selected-item-Connectivity"
                          >
                            {iccid}

                            <button
                              type="button"
                              className="cco-remove-item-Connectivity"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeICCID(iccid);
                              }}
                            >
                              ×
                            </button>
                          </span>
                        ))}
                      </div>
                    )}

                    <i
                      className={`fas ${
                        iccidDropdownOpen ? "fa-chevron-up" : "fa-chevron-down"
                      } cco-dropdown-icon-Connectivity`}
                    ></i>
                  </div>

                  {iccidDropdownOpen && (
                    <div className="cco-dropdown-menu-Connectivity">
                      {availableICCIDs.length > 0 ? (
                        availableICCIDs.map((iccid) => (
                          <div
                            key={iccid}
                            className="cco-dropdown-option-Connectivity"
                            onClick={() => toggleICCID(iccid)}
                          >
                            {iccid}
                          </div>
                        ))
                      ) : (
                        <div className="cco-no-options-Connectivity">
                          All ICCIDs selected
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {showMKYC && (
          <div className="cco-section-Connectivity">
            <h3 className="cco-section-title-Connectivity">
              <i className="fas fa-user-check"></i> MKYC Entity
            </h3>

            <div className="cco-fields-grid-Connectivity">
              {readOnlyField("deviceModel", "Device Model")}

              {readOnlyField("deviceMake", "Device Make")}

              {readOnlyField("engineNo", "Engine Number")}

              {readOnlyField("chassisNo", "Chassis Number")}

              {readOnlyField("vehicleRegNo", "Vehicle Registration Number")}

              {readOnlyField("ownerName", "Owner Name")}

              {readOnlyField("ownerMobile", "Owner Mobile")}

              {readOnlyField("ownerAddress", "Owner Address")}

              {readOnlyField("poiDocNo", "POI Document Number")}

              {readOnlySelect(
                "proofOfIdentityTypeStr",
                "Proof of Identity Type",
              )}

              {readOnlyField("poaDocNo", "POA Document Number")}

              {readOnlySelect("proofOfAddressTypeStr", "Proof of Address Type")}
            </div>
          </div>
        )}

        <div className="cco-footer-Connectivity">
          <button className="cco-cancel-Connectivity" onClick={onBack}>
            Cancel
          </button>

          <button
            className="cco-activate-Connectivity"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Creating...
              </>
            ) : (
              <>
                <i className="fas fa-bolt"></i> Create CCO Request
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

const CCOApprovalPage = ({ onBack }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [rejectSuccessMessage, setRejectSuccessMessage] = useState("");
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [expandedRequest, setExpandedRequest] = useState(null);
  const [comment, setComment] = useState("");
  const [actionFilter, setActionFilter] = useState("");
  const [iccidFilter, setIccidFilter] = useState("");

  const actionOptions = [
    "Commercial Activation",
    "Suspension",
    "Renewal",
    "Top-Up",
    "Mkyc-Update",
  ];

  const [checklist, setChecklist] = useState({
    commercialDetails: false,
    customerSimDetails: false,
    configurationDetails: false,
  });

  const token = localStorage.getItem("token");

  const fetchPendingRequests = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const response = await fetch(`${API_BASE_URL}/cco-requests`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch CCO requests");
      }

      const data = await response.json();

      const requestList = Array.isArray(data)
        ? data
        : Array.isArray(data.data)
          ? data.data
          : Array.isArray(data.requests)
            ? data.requests
            : [];

      setRequests(requestList);
    } catch (err) {
      console.error("Error fetching CCO requests:", err);
      setError(err.message || "Failed to load CCO requests");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchPendingRequests();
  }, [fetchPendingRequests]);

  const getRequestIccid = (request) => {
    if (request.iccid) {
      return request.iccid;
    }

    if (request.ICCID) {
      return request.ICCID;
    }

    if (request.iccids) {
      if (Array.isArray(request.iccids)) {
        return request.iccids.join(", ");
      }

      return request.iccids;
    }

    if (request.ICCIDList) {
      if (Array.isArray(request.ICCIDList)) {
        return request.ICCIDList.join(", ");
      }

      return request.ICCIDList;
    }

    return "-";
  };

  const getRequestId = (request) => {
    return (
      request.requestId ||
      request.request_id ||
      request.id ||
      request.RequestID ||
      "-"
    );
  };

  const getRequestAction = (request) => {
    return String(
      request.action || request.Action || request.requestAction || "",
    ).trim();
  };

  const filteredRequests = requests.filter((request) => {
    const requestAction = String(
      request.action || request.Action || request.requestAction || "",
    ).toLowerCase();

    const requestIccid = String(getRequestIccid(request)).toLowerCase();

    const selectedAction = actionFilter.toLowerCase();
    const enteredIccid = iccidFilter.toLowerCase().trim();

    const matchesAction = !selectedAction || requestAction === selectedAction;
    const matchesIccid = !enteredIccid || requestIccid.includes(enteredIccid);

    return matchesAction && matchesIccid;
  });

  const toggleRequest = (requestId) => {
    setError("");
    setSuccessMessage("");
    setRejectSuccessMessage("");

    const request = requests.find((item) => getRequestId(item) === requestId);

    if (!request) return;

    const requestAction = getRequestAction(request);

    setSelectedRequests((prev) => {
      if (prev.includes(requestId)) {
        const updatedSelection = prev.filter((id) => id !== requestId);

        if (updatedSelection.length === 0) {
          setError("");
        }

        return updatedSelection;
      }

      if (prev.length === 0) {
        setError("");
        return [requestId];
      }

      const firstSelectedRequest = requests.find(
        (item) => getRequestId(item) === prev[0],
      );

      const selectedAction = firstSelectedRequest
        ? getRequestAction(firstSelectedRequest)
        : "";

      if (selectedAction !== requestAction) {
        setError(
          `You can only select requests with the same action. Selected action: ${selectedAction}`,
        );

        return prev;
      }

      setError("");

      return [...prev, requestId];
    });
  };

  const toggleDetails = (requestId) => {
    setExpandedRequest((prev) => (prev === requestId ? null : requestId));
  };

  const toggleAll = () => {
    const filteredIds = filteredRequests.map((request) =>
      getRequestId(request),
    );

    const allSelected =
      filteredIds.length > 0 &&
      filteredIds.every((id) => selectedRequests.includes(id));

    if (allSelected) {
      setSelectedRequests((prev) =>
        prev.filter((id) => !filteredIds.includes(id)),
      );

      setError("");
      return;
    }

    if (selectedRequests.length > 0) {
      const firstSelectedRequest = requests.find(
        (request) => getRequestId(request) === selectedRequests[0],
      );

      const selectedAction = firstSelectedRequest
        ? getRequestAction(firstSelectedRequest)
        : "";

      const sameActionIds = filteredRequests
        .filter((request) => getRequestAction(request) === selectedAction)
        .map((request) => getRequestId(request));

      setSelectedRequests((prev) => [...new Set([...prev, ...sameActionIds])]);

      setError("");
      return;
    }

    const actions = [
      ...new Set(filteredRequests.map((request) => getRequestAction(request))),
    ];

    if (actions.length > 1) {
      setError(
        "Select All cannot be used because the list contains different actions. Please select requests with the same action.",
      );
      return;
    }

    setSelectedRequests(filteredIds);
    setError("");
  };

  const updateChecklist = (field) => {
    setError("");
    setSuccessMessage("");
    setRejectSuccessMessage("");

    setChecklist((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const allChecklistCompleted =
    checklist.commercialDetails &&
    checklist.customerSimDetails &&
    checklist.configurationDetails;

  const resetApprovalForm = () => {
    setSelectedRequests([]);
    setComment("");
    setExpandedRequest(null);
    setChecklist({
      commercialDetails: false,
      customerSimDetails: false,
      configurationDetails: false,
    });
  };

  const handleApprove = async () => {
    setError("");
    setSuccessMessage("");
    setRejectSuccessMessage("");

    if (selectedRequests.length === 0) {
      setError("Please select at least one request.");
      return;
    }

    if (!allChecklistCompleted) {
      setError("Please complete all approval checklist items.");
      return;
    }

    if (!comment.trim()) {
      setError("Please enter a comment.");
      return;
    }

    const approvedCount = selectedRequests.length;

    try {
      const response = await fetch(`${API_BASE_URL}/cco-requests/approve`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          requestIds: selectedRequests,
          comment: comment.trim(),
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        setError(
          result.error || result.message || "Failed to approve CCO requests.",
        );
        return;
      }

      setRequests((prev) =>
        prev.filter(
          (request) => !selectedRequests.includes(getRequestId(request)),
        ),
      );

      resetApprovalForm();

      if (result.sensoriseResponseCode === "SENSORISE_ERROR") {
        setSuccessMessage(
          `${approvedCount} request${
            approvedCount !== 1 ? "s" : ""
          } approved successfully, but Sensorise failed: ${
            result.sensoriseResponseMsg || "Unknown error"
          }`,
        );
      } else {
        setSuccessMessage(
          `${approvedCount} request${
            approvedCount !== 1 ? "s" : ""
          } approved successfully.${
            result.sensoriseResponseMsg ? ` ${result.sensoriseResponseMsg}` : ""
          }`,
        );
      }
    } catch (err) {
      console.error("Approve error:", err);
      setError("Server error while approving CCO requests.");
    }
  };

  const handleReject = async () => {
    setError("");
    setSuccessMessage("");
    setRejectSuccessMessage("");

    if (selectedRequests.length === 0) {
      setError("Please select at least one request.");
      return;
    }

    if (!allChecklistCompleted) {
      setError("Please complete all approval checklist items.");
      return;
    }

    if (!comment.trim()) {
      setError("Please enter a comment.");
      return;
    }

    const rejectedCount = selectedRequests.length;

    try {
      const response = await fetch(`${API_BASE_URL}/cco-requests/reject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          requestIds: selectedRequests,
          comment: comment.trim(),
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        setError(
          result.error || result.message || "Failed to reject CCO requests.",
        );
        return;
      }

      setRequests((prev) =>
        prev.filter(
          (request) => !selectedRequests.includes(getRequestId(request)),
        ),
      );

      resetApprovalForm();

      setRejectSuccessMessage(
        `${rejectedCount} request${
          rejectedCount !== 1 ? "s" : ""
        } rejected successfully.`,
      );
    } catch (err) {
      console.error("Reject error:", err);
      setRejectSuccessMessage("");
      setError("Server error while rejecting CCO requests.");
    }
  };

  const clearFilters = () => {
    setActionFilter("");
    setIccidFilter("");
    setSuccessMessage("");
    setRejectSuccessMessage("");
    setError("");
  };

  return (
    <div className="cco-approval-wrapper-Connectivity">
      <div className="cco-approval-header-Connectivity">
        <div>
          <h1 className="cco-approval-title-Connectivity">
            Review CCO Request
          </h1>

          <p className="cco-approval-subtitle-Connectivity">
            verify the submitted information before approving the request.
          </p>
        </div>

        <div className="cco-header-actions-Connectivity">
          <button
            type="button"
            className="cco-btn-back-Connectivity"
            onClick={onBack}
          >
            Back
          </button>

          <button
            type="button"
            className="cco-refresh-btn-Connectivity"
            onClick={fetchPendingRequests}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div>
      </div>

      <div className="cco-approval-main-card-Connectivity">
        <div className="cco-filter-bar-Connectivity">
          <div className="cco-filter-group-Connectivity">
            <label className="cco-filter-label-Connectivity">Action</label>

            <select
              className="cco-filter-select-Connectivity"
              value={actionFilter}
              onChange={(e) => {
                setActionFilter(e.target.value);
                setSuccessMessage("");
                setRejectSuccessMessage("");
                setError("");
              }}
            >
              <option value="">All Actions</option>

              {actionOptions.map((action) => (
                <option key={action} value={action}>
                  {action}
                </option>
              ))}
            </select>
          </div>

          <div className="cco-filter-group-Connectivity">
            <label htmlFor="cco-iccid-filter">ICCID</label>

            <input
              id="cco-iccid-filter"
              type="text"
              value={iccidFilter}
              onChange={(e) => {
                setIccidFilter(e.target.value);
                setSuccessMessage("");
                setRejectSuccessMessage("");
                setError("");
              }}
              placeholder="Search ICCID"
              className="cco-filter-input-Connectivity"
            />
          </div>

          <button
            type="button"
            className="cco-clear-filter-Connectivity"
            onClick={clearFilters}
          >
            Clear Filters
          </button>
        </div>

        {error && <div className="cco-error-message-Connectivity">{error}</div>}

        {successMessage && (
          <div className="cco-action-success-Connectivity">
            <i className="fas fa-check-circle"></i>
            {successMessage}
          </div>
        )}

        {rejectSuccessMessage && (
          <div className="cco-action-reject-success-Connectivity">
            <i className="fas fa-times-circle"></i>
            {rejectSuccessMessage}
          </div>
        )}

        {loading ? (
          <div className="cco-loading-Connectivity">
            Loading pending CCO requests...
          </div>
        ) : requests.length === 0 ? (
          <div className="cco-empty-Connectivity">
            No pending CCO requests found.
          </div>
        ) : filteredRequests.length === 0 ? (
          <div className="cco-no-filter-results-Connectivity">
            No requests match the selected filters.
          </div>
        ) : (
          <>
            <div className="cco-request-header-row-Connectivity">
              <div className="cco-request-column-Connectivity checkbox-column-Connectivity">
                <input
                  type="checkbox"
                  checked={
                    filteredRequests.length > 0 &&
                    filteredRequests.every((request) =>
                      selectedRequests.includes(getRequestId(request)),
                    )
                  }
                  onChange={toggleAll}
                />
              </div>

              <div className="cco-request-column-Connectivity">ICCID</div>
              <div className="cco-request-column-Connectivity">BATCH ID</div>
              <div className="cco-request-column-Connectivity">ACTION</div>
              <div className="cco-request-column-Connectivity">CREATED BY</div>
              <div className="cco-request-column-Connectivity">CREATED ON</div>

              <div className="cco-request-column-Connectivity view-column-Connectivity">
                VIEW DETAILS
              </div>
            </div>

            <div className="cco-pending-requests-Connectivity">
              {filteredRequests.map((request, index) => {
                const requestId = getRequestId(request);
                const iccid = getRequestIccid(request);

                const batchId =
                  request.batchId ||
                  request.batch_id ||
                  request.BatchID ||
                  "N/A";

                const action =
                  request.action ||
                  request.Action ||
                  request.requestAction ||
                  "N/A";

                const createdBy =
                  request.createdBy ||
                  request.created_by ||
                  request.CreatedBy ||
                  request.username ||
                  "N/A";

                const createdOn =
                  request.createdOn ||
                  request.created_at ||
                  request.createdAt ||
                  request.CreatedOn ||
                  "N/A";

                return (
                  <div
                    key={`${requestId}-${index}`}
                    className="cco-request-box-Connectivity"
                  >
                    <div className="cco-request-info-row-Connectivity">
                      <div className="cco-request-info-item-Connectivity checkbox-column-Connectivity">
                        <input
                          type="checkbox"
                          checked={selectedRequests.includes(requestId)}
                          disabled={
                            selectedRequests.length > 0 &&
                            !selectedRequests.includes(requestId) &&
                            getRequestAction(request) !==
                              getRequestAction(
                                requests.find(
                                  (item) =>
                                    getRequestId(item) === selectedRequests[0],
                                ) || {},
                              )
                          }
                          onChange={() => toggleRequest(requestId)}
                        />
                      </div>

                      <div className="cco-request-info-item-Connectivity">
                        <span>{iccid}</span>
                      </div>

                      <div className="cco-request-info-item-Connectivity">
                        <span>{batchId}</span>
                      </div>

                      <div className="cco-request-info-item-Connectivity">
                        <span>{action}</span>
                      </div>

                      <div className="cco-request-info-item-Connectivity">
                        <span>{createdBy}</span>
                      </div>

                      <div className="cco-request-info-item-Connectivity">
                        <span>{createdOn}</span>
                      </div>

                      <div className="cco-request-info-item-Connectivity view-column-Connectivity">
                        <button
                          type="button"
                          className="cco-view-details-Connectivity"
                          onClick={() => toggleDetails(requestId)}
                        >
                          {expandedRequest === requestId
                            ? "Hide Details"
                            : "View Details"}
                        </button>
                      </div>
                    </div>

                    {expandedRequest === requestId && (
                      <div className="cco-request-details-wrapper-Connectivity">
                        <div className="cco-review-section-card-Connectivity">
                          <h3 className="cco-section-subheading-Connectivity">
                            Request & Customer
                          </h3>

                          <div className="cco-review-grid-Connectivity">
                            <div className="cco-review-grid-item-Connectivity">
                              <span>Request ID</span>
                              <strong>{requestId}</strong>
                            </div>

                            <div className="cco-review-grid-item-Connectivity">
                              <span>Project Name</span>
                              <strong>
                                {request.projectName ||
                                  request.project_name ||
                                  "N/A"}
                              </strong>
                            </div>

                            <div className="cco-review-grid-item-Connectivity">
                              <span>Product Name</span>
                              <strong>
                                {request.productName ||
                                  request.product_name ||
                                  "N/A"}
                              </strong>
                            </div>

                            <div className="cco-review-grid-item-Connectivity">
                              <span>Customer ID</span>
                              <strong>
                                {request.customerId ||
                                  request.customer_id ||
                                  request.CustomerID ||
                                  "N/A"}
                              </strong>
                            </div>

                            <div className="cco-review-grid-item-Connectivity">
                              <span>ICCID</span>
                              <strong>{iccid}</strong>
                            </div>

                            <div className="cco-review-grid-item-Connectivity">
                              <span>Request Date</span>
                              <strong>
                                {request.requestDate ||
                                  request.request_date ||
                                  request.createdOn ||
                                  request.created_at ||
                                  "N/A"}
                              </strong>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="cco-common-review-card-Connectivity">
              <h3 className="cco-common-section-title-Connectivity">
                <i className="fas fa-check-circle"></i>
                Approval Checklist
              </h3>

              <div className="cco-checklist-container-Connectivity">
                <label className="cco-checklist-item-Connectivity">
                  <input
                    type="checkbox"
                    checked={checklist.commercialDetails}
                    onChange={() => updateChecklist("commercialDetails")}
                  />
                  <span>Commercial details verified</span>
                </label>

                <label className="cco-checklist-item-Connectivity">
                  <input
                    type="checkbox"
                    checked={checklist.customerSimDetails}
                    onChange={() => updateChecklist("customerSimDetails")}
                  />
                  <span>Customer / SIM details verified</span>
                </label>

                <label className="cco-checklist-item-Connectivity">
                  <input
                    type="checkbox"
                    checked={checklist.configurationDetails}
                    onChange={() => updateChecklist("configurationDetails")}
                  />
                  <span>Configuration details verified</span>
                </label>
              </div>
            </div>

            <div className="cco-common-review-card-Connectivity">
              <h3 className="cco-common-section-title-Connectivity">Comment</h3>

              <label className="cco-comment-label-Connectivity">
                Add your comment{" "}
                <span className="required-star-Connectivity">*</span>
              </label>

              <textarea
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                  setError("");
                  setSuccessMessage("");
                  setRejectSuccessMessage("");
                }}
                placeholder="Enter comment..."
                className="cco-comment-textarea-Connectivity"
                rows={4}
              />
            </div>

            <div className="cco-common-footer-Connectivity">
              <div className="cco-common-footer-left-Connectivity">
                <span>
                  {selectedRequests.length} request
                  {selectedRequests.length !== 1 ? "s" : ""} selected
                </span>
              </div>

              <div className="cco-common-footer-actions-Connectivity">
                <button
                  type="button"
                  className="cco-btn-approve-Connectivity"
                  onClick={handleApprove}
                >
                  Approve
                </button>

                <button
                  type="button"
                  className="cco-btn-reject-Connectivity"
                  onClick={handleReject}
                >
                  Reject
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

function ConnectivityDashboard() {
  const simStatusChartRef = useRef(null);
  const monthlyUsageChartRef = useRef(null);
  const simStatusChartInstance = useRef(null);
  const monthlyUsageChartInstance = useRef(null);
  const expirySyncTimeoutRef = useRef(null);
  const [auth, setAuth] = useState(null);
  const [page, setPage] = useState("dashboard");
  const [simData, setSimData] = useState([]);
  const [statusCount, setStatusCount] = useState({});
  const [isConnecting, setIsConnecting] = useState(false);
  const [totalIccidCount, setTotalIccidCount] = useState(() => {
    const storedCount = localStorage.getItem("connectivity_total_iccid_count");
    return storedCount !== null ? Number(storedCount) : 0;
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ccoStatusData, setCcoStatusData] = useState([]);
  const [ccoStatusLoading, setCcoStatusLoading] = useState(false);
  const [ccoStatusError, setCcoStatusError] = useState("");
  const [ccoIccidModal, setCcoIccidModal] = useState(false);
  const [selectedCcoSrId, setSelectedCcoSrId] = useState("");
  const [selectedCcoIccids, setSelectedCcoIccids] = useState([]);
  const [ccoStatusPage, setCcoStatusPage] = useState(1);
  const [ccoStatusTotalPages, setCcoStatusTotalPages] = useState(1);
  const [ccoStatusTotalRecords, setCcoStatusTotalRecords] = useState(0);
  const [ccoDateRange, setCcoDateRange] = useState("today");
  const [ccoStartDate, setCcoStartDate] = useState("");
  const [ccoEndDate, setCcoEndDate] = useState("");
  const [ticketStatusRequests, setTicketStatusRequests] = useState([]);
  const [ticketStatusRequestsLoading, setTicketStatusRequestsLoading] =
    useState(false);
  const [ticketStatusRequestsError, setTicketStatusRequestsError] =
    useState("");
  const [ticketStatusPage, setTicketStatusPage] = useState(1);
  const [ticketStatusTotalPages, setTicketStatusTotalPages] = useState(1);
  const [ticketStatusTotalRecords, setTicketStatusTotalRecords] = useState(0);
  const [ticketDateRange, setTicketDateRange] = useState("today");
  const [ticketStartDate, setTicketStartDate] = useState("");
  const [ticketEndDate, setTicketEndDate] = useState("");
  const [ticketStatusModal, setTicketStatusModal] = useState(false);
  const [ticketStatusLoading, setTicketStatusLoading] = useState(false);
  const [ticketStatusData, setTicketStatusData] = useState(null);
  const [ticketStatusError, setTicketStatusError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    return () => {
      if (expirySyncTimeoutRef.current) {
        clearTimeout(expirySyncTimeoutRef.current);
        expirySyncTimeoutRef.current = null;
      }
    };
  }, []);

  const handleConnect = async (
    pageNumber = currentPage,
    scheduleExpirySync = false,
  ) => {
    if (isConnecting) return;

    setIsConnecting(true);

    try {
      const res = await fetch(
        `${API_BASE_URL}/get-sim-data?page=${pageNumber}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await res.json();

      if (!res.ok) {
        throw new Error(result.error || "Failed to fetch SIM data.");
      }

      setSimData(result.simData || []);
      setStatusCount(result.statusCount || {});

      let dbIccidCount = 0;

      if (result.pagination) {
        dbIccidCount = Number(result.pagination.total || 0);
      } else if (result.totalRecords !== undefined) {
        dbIccidCount = Number(result.totalRecords || 0);
      } else if (result.total !== undefined) {
        dbIccidCount = Number(result.total || 0);
      } else {
        dbIccidCount = Number((result.simData || []).length);
      }

      setTotalIccidCount(dbIccidCount);

      localStorage.setItem(
        "connectivity_total_iccid_count",
        String(dbIccidCount),
      );

      if (result.pagination) {
        setCurrentPage(result.pagination.page || pageNumber);
        setTotalPages(result.pagination.total_pages || 1);
        setTotalRecords(result.pagination.total || 0);
      } else {
        setCurrentPage(pageNumber);
        setTotalPages(1);
        setTotalRecords(dbIccidCount);
      }

      if (scheduleExpirySync) {
        if (expirySyncTimeoutRef.current) {
          clearTimeout(expirySyncTimeoutRef.current);
        }

        expirySyncTimeoutRef.current = setTimeout(async () => {
          expirySyncTimeoutRef.current = null;

          try {
            const syncResponse = await fetch(
              `${API_BASE_URL}/sync-sim-expiry`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            let syncResult = {};

            try {
              syncResult = await syncResponse.json();
            } catch (parseError) {
              syncResult = {};
            }

            if (!syncResponse.ok) {
              throw new Error(
                syncResult.error ||
                  syncResult.message ||
                  "Failed to synchronize SIM expiry dates.",
              );
            }
          } catch (error) {
            console.error("SIM expiry synchronization failed:", error);
          }
        }, 3 * 1000);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsConnecting(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages && !isConnecting) {
      handleConnect(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1 && !isConnecting) {
      handleConnect(currentPage - 1);
    }
  };

  const handleViewCcoStatus = async (pageNumber = ccoStatusPage) => {
    if (ccoStatusLoading) return;

    if (ccoDateRange === "custom" && (!ccoStartDate || !ccoEndDate)) {
      setCcoStatusError("Please select both start date and end date.");
      return;
    }

    if (ccoDateRange === "custom" && ccoStartDate > ccoEndDate) {
      setCcoStatusError("Start date cannot be greater than end date.");
      return;
    }

    setCcoStatusLoading(true);
    setCcoStatusError("");

    try {
      const response = await fetch(`${API_BASE_URL}/cco-requests/status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          selected: false,
          srId: null,
          page: pageNumber,
          dateRange: ccoDateRange,
          startDate: ccoDateRange === "custom" ? ccoStartDate : null,
          endDate: ccoDateRange === "custom" ? ccoEndDate : null,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || result.error || "Failed to fetch CCO status.",
        );
      }

      if (result.success) {
        setCcoStatusData(result.data || []);

        if (result.pagination) {
          setCcoStatusPage(result.pagination.page || pageNumber);
          setCcoStatusTotalPages(result.pagination.total_pages || 1);
          setCcoStatusTotalRecords(result.pagination.total || 0);
        } else {
          setCcoStatusPage(pageNumber);
          setCcoStatusTotalPages(1);
          setCcoStatusTotalRecords((result.data || []).length);
        }
      } else {
        setCcoStatusData([]);
        setCcoStatusPage(1);
        setCcoStatusTotalPages(1);
        setCcoStatusTotalRecords(0);
        setCcoStatusError(result.message || "Failed to fetch CCO status.");
      }
    } catch (error) {
      console.error("Error fetching CCO status:", error);
      setCcoStatusError(error.message || "Failed to fetch CCO status.");
      setCcoStatusData([]);
      setCcoStatusPage(1);
      setCcoStatusTotalPages(1);
      setCcoStatusTotalRecords(0);
    } finally {
      setCcoStatusLoading(false);
    }
  };

  const handleViewCcoIccids = (item) => {
    setSelectedCcoSrId(item.srid || "");
    setSelectedCcoIccids(item.iccids || []);
    setCcoIccidModal(true);
  };

  const handleCloseCcoIccidModal = () => {
    setCcoIccidModal(false);
    setSelectedCcoSrId("");
    setSelectedCcoIccids([]);
  };

  const handleCcoStatusNextPage = () => {
    if (ccoStatusPage < ccoStatusTotalPages && !ccoStatusLoading) {
      handleViewCcoStatus(ccoStatusPage + 1);
    }
  };

  const handleCcoStatusPreviousPage = () => {
    if (ccoStatusPage > 1 && !ccoStatusLoading) {
      handleViewCcoStatus(ccoStatusPage - 1);
    }
  };

  const handleCcoDateRangeChange = (value) => {
    setCcoDateRange(value);
    setCcoStatusPage(1);
    setCcoStatusData([]);
    setCcoStatusTotalPages(1);
    setCcoStatusTotalRecords(0);
    setCcoStatusError("");

    if (value !== "custom") {
      setCcoStartDate("");
      setCcoEndDate("");
    }
  };

  const handleViewTicketStatusRequests = async (
    pageNumber = ticketStatusPage,
  ) => {
    if (ticketStatusRequestsLoading) return;

    if (ticketDateRange === "custom" && (!ticketStartDate || !ticketEndDate)) {
      setTicketStatusRequestsError(
        "Please select both start date and end date.",
      );
      return;
    }

    if (ticketDateRange === "custom" && ticketStartDate > ticketEndDate) {
      setTicketStatusRequestsError(
        "Start date cannot be greater than end date.",
      );
      return;
    }

    setTicketStatusRequestsLoading(true);
    setTicketStatusRequestsError("");

    try {
      const params = new URLSearchParams();
      params.append("dateRange", ticketDateRange);
      params.append("page", pageNumber);

      if (ticketDateRange === "custom") {
        params.append("startDate", ticketStartDate);
        params.append("endDate", ticketEndDate);
      }

      const response = await fetch(
        `${API_BASE_URL}/ticket-status-requests?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.message || result.error || "Failed to fetch ticket requests.",
        );
      }

      if (result.success) {
        setTicketStatusRequests(result.data || []);

        if (result.pagination) {
          setTicketStatusPage(result.pagination.page || pageNumber);
          setTicketStatusTotalPages(result.pagination.total_pages || 1);
          setTicketStatusTotalRecords(result.pagination.total || 0);
        } else {
          setTicketStatusPage(pageNumber);
          setTicketStatusTotalPages(1);
          setTicketStatusTotalRecords((result.data || []).length);
        }
      } else {
        setTicketStatusRequests([]);
        setTicketStatusPage(1);
        setTicketStatusTotalPages(1);
        setTicketStatusTotalRecords(0);
        setTicketStatusRequestsError(
          result.message || "Failed to fetch ticket requests.",
        );
      }
    } catch (error) {
      console.error("Error fetching ticket status requests:", error);
      setTicketStatusRequestsError(
        error.message || "Failed to fetch ticket requests.",
      );
      setTicketStatusRequests([]);
      setTicketStatusPage(1);
      setTicketStatusTotalPages(1);
      setTicketStatusTotalRecords(0);
    } finally {
      setTicketStatusRequestsLoading(false);
    }
  };

  const handleTicketStatusNextPage = () => {
    if (
      ticketStatusPage < ticketStatusTotalPages &&
      !ticketStatusRequestsLoading
    ) {
      handleViewTicketStatusRequests(ticketStatusPage + 1);
    }
  };

  const handleTicketStatusPreviousPage = () => {
    if (ticketStatusPage > 1 && !ticketStatusRequestsLoading) {
      handleViewTicketStatusRequests(ticketStatusPage - 1);
    }
  };

  const handleTicketDateRangeChange = (value) => {
    setTicketDateRange(value);
    setTicketStatusPage(1);
    setTicketStatusRequests([]);
    setTicketStatusTotalPages(1);
    setTicketStatusTotalRecords(0);
    setTicketStatusRequestsError("");

    if (value !== "custom") {
      setTicketStartDate("");
      setTicketEndDate("");
    }
  };

  const handleViewTicketStatus = async (ticketNo) => {
    if (ticketStatusLoading) return;

    setTicketStatusModal(true);
    setTicketStatusLoading(true);
    setTicketStatusError("");
    setTicketStatusData(null);

    try {
      const response = await fetch(`${API_BASE_URL}/ticket-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          tokenId: ticketNo,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.error || result.message || "Failed to fetch ticket status.",
        );
      }

      if (result.success) {
        setTicketStatusData(result.data || null);
      } else {
        setTicketStatusError(
          result.error || result.message || "Failed to fetch ticket status.",
        );
      }
    } catch (error) {
      console.error("Error fetching ticket status:", error);
      setTicketStatusError(error.message || "Failed to fetch ticket status.");
    } finally {
      setTicketStatusLoading(false);
    }
  };

  const handleCloseTicketStatus = () => {
    setTicketStatusModal(false);
    setTicketStatusData(null);
    setTicketStatusError("");
    setTicketStatusLoading(false);
  };

  const handleRegisterClick = () => {
    setPage("register");
  };

  const handleBackToDashboard = () => {
    setPage("dashboard");
  };

  const simStatusData = React.useMemo(
    () => ({
      labels: ["Active", "Inactive", "Expired", "Suspended", "Other"],
      counts: [
        statusCount?.ACTIVE || 0,
        statusCount?.INACTIVE || 0,
        statusCount?.EXPIRED || 0,
        statusCount?.SUSPEND || 0,
        statusCount?.OTHER || 0,
      ],
      colors: ["#34D399", "#FBBF24", "#F87171", "#EF4444", "#7e4dee"],
    }),
    [statusCount],
  );

  const monthlyUsageChartData = React.useMemo(
    () => ({
      labels: [
        "Jun 23",
        "Jul 23",
        "Aug 23",
        "Sep 23",
        "Oct 23",
        "Nov 23",
        "Dec 23",
        "Jan 24",
        "Feb 24",
        "Mar 24",
        "Apr 24",
        "May 24",
      ],
      prepaid: [65, 70, 68, 72, 75, 80, 78, 85, 82, 88, 90, 85],
      subscription: [40, 35, 42, 38, 30, 25, 30, 28, 35, 32, 28, 25],
      paygo: [20, 25, 15, 20, 30, 25, 27, 22, 28, 20, 25, 20],
    }),
    [],
  );

  useEffect(() => {
    if (page !== "dashboard") return;
    if (!simStatusChartRef.current) return;

    const ctx = simStatusChartRef.current.getContext("2d");

    if (simStatusChartInstance.current) {
      simStatusChartInstance.current.destroy();
    }

    simStatusChartInstance.current = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: simStatusData.labels,
        datasets: [
          {
            data: simStatusData.counts,
            backgroundColor: simStatusData.colors,
            borderColor: "white",
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "70%",
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
      },
    });

    return () => {
      if (simStatusChartInstance.current) {
        simStatusChartInstance.current.destroy();
        simStatusChartInstance.current = null;
      }
    };
  }, [page, simStatusData]);

  useEffect(() => {
    if (page !== "dashboard") return;
    if (!monthlyUsageChartRef.current) return;

    const ctx = monthlyUsageChartRef.current.getContext("2d");

    if (monthlyUsageChartInstance.current) {
      monthlyUsageChartInstance.current.destroy();
    }

    const maxUsage = Math.max(
      ...monthlyUsageChartData.labels.map(
        (_, i) =>
          monthlyUsageChartData.prepaid[i] +
          monthlyUsageChartData.subscription[i] +
          monthlyUsageChartData.paygo[i],
      ),
    );

    monthlyUsageChartInstance.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: monthlyUsageChartData.labels.slice(-8),
        datasets: [
          {
            label: "Prepaid",
            data: monthlyUsageChartData.prepaid.slice(-8),
            backgroundColor: "#60A5FA",
            borderRadius: 4,
          },
          {
            label: "Subscription",
            data: monthlyUsageChartData.subscription.slice(-8),
            backgroundColor: "#FBBF24",
            borderRadius: 4,
          },
          {
            label: "PAYGO",
            data: monthlyUsageChartData.paygo.slice(-8),
            backgroundColor: "#34D399",
            borderRadius: 4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: "#6B7280",
            },
          },
          y: {
            stacked: true,
            beginAtZero: true,
            max: Math.ceil(maxUsage / 10) * 10,
            ticks: {
              color: "#6B7280",
            },
            grid: {
              color: "#E5E7EB",
            },
          },
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 12,
              boxHeight: 12,
              font: {
                size: 12,
              },
              color: "#374151",
            },
          },
        },
      },
    });

    return () => {
      if (monthlyUsageChartInstance.current) {
        monthlyUsageChartInstance.current.destroy();
        monthlyUsageChartInstance.current = null;
      }
    };
  }, [page, monthlyUsageChartData]);

  if (page === "register") {
    return (
      <CCORegisterPage
        auth={auth}
        simData={simData}
        onBack={handleBackToDashboard}
      />
    );
  }

  if (page === "approval") {
    return <CCOApprovalPage onBack={handleBackToDashboard} />;
  }

  if (page === "ticket") {
    return <RaiseTicketPage onBack={handleBackToDashboard} />;
  }

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
      />
      <div className="session-bar-Connectivity">
        <span>
          <i className="fas fa-circle session-dot-Connectivity"></i> Connected
          as <strong>{auth?.relationId || "User"}</strong>
        </span>
        <button
          className="session-logout-Connectivity"
          onClick={() => {
            setAuth(null);
            setPage("login");
          }}
        >
          <i className="fas fa-sign-out-alt"></i> Disconnect
        </button>
      </div>

      <div className="mainContainer-Connectivity">
        <div className="tableContainer-Connectivity customShadow-Connectivity">
          <div className="tableHeader-Connectivity">
            <div className="tableHeaderActions-Connectivity">
              <button
                className="buttonIcon-Connectivity connect-Button"
                onClick={() => {
                  setCurrentPage(1);
                  handleConnect(1, true);
                }}
                disabled={isConnecting}
              >
                {isConnecting ? (
                  <>
                    <i
                      className="fas fa-spinner fa-spin"
                      style={{
                        marginRight: "0.5rem",
                      }}
                    ></i>
                    Connecting...
                  </>
                ) : (
                  <>
                    Connect
                    <i
                      className="fas fa-plug"
                      style={{
                        marginLeft: "0.5rem",
                      }}
                    ></i>
                  </>
                )}
              </button>

              <button
                className="buttonPrimary-Connectivity"
                onClick={handleRegisterClick}
              >
                <i
                  className="fas fa-plus"
                  style={{
                    marginRight: "0.5rem",
                  }}
                ></i>
                Create CCO Request
              </button>

              <button
                className="buttonSecondary-Connectivity"
                onClick={() => setPage("ticket")}
              >
                <i
                  className="fas fa-ticket-alt"
                  style={{
                    marginRight: "0.5rem",
                  }}
                ></i>
                Raise Ticket Request
              </button>

              <button
                className="buttonSecondary-Connectivity"
                onClick={() => setPage("approval")}
              >
                <i
                  className="fas fa-check-circle"
                  style={{
                    marginRight: "0.5rem",
                  }}
                ></i>
                CCO Request Approve
              </button>

              <button className="buttonIcon-Connectivity">
                <i className="fas fa-cog"></i>
              </button>
            </div>
          </div>

          <div className="tableSearch-Connectivity">
            <div className="tableSearch-Connectivity-i">
              <div className="searchInput-Connectivity">
                <i className="fas fa-search searchIcon-Connectivity"></i>
                <input
                  type="text"
                  className="searchInputField-Connectivity"
                  placeholder="Search by any attribute"
                />
              </div>

              <button className="buttonSecondary-Connectivity">
                Any
                <i
                  className="fas fa-chevron-down"
                  style={{
                    marginLeft: "0.5rem",
                    fontSize: "0.75rem",
                  }}
                ></i>
              </button>

              <button className="buttonIcon-Connectivity">
                <i className="fas fa-search"></i>
              </button>
            </div>

            <div className="tablePagination-Connectivity">
              <div className="paginationInfo-Connectivity">
                {totalRecords === 0
                  ? "Items 0-0"
                  : `Items ${(currentPage - 1) * 5 + 1}-${Math.min(
                      currentPage * 5,
                      totalRecords,
                    )} of ${totalRecords}`}
              </div>

              <div className="paginationControls-Connectivity">
                <button
                  className="paginationButton-Connectivity"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1 || isConnecting}
                >
                  Prev
                </button>

                <button
                  className="paginationButton-Connectivity"
                  onClick={handleNextPage}
                  disabled={currentPage >= totalPages || isConnecting}
                >
                  Next
                </button>

                <div className="paginationSelect-Connectivity">
                  <select
                    className="paginationSelectField-Connectivity"
                    value="5"
                    disabled
                  >
                    <option value="5">5</option>
                  </select>
                  <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
                </div>
              </div>
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="table-Connectivity">
              <thead className="tableHead-Connectivity">
                <tr>
                  <th
                    className="tableHeaderCell-Connectivity tableHeaderCellFirst-Connectivity"
                    style={{
                      width: "40px",
                    }}
                  >
                    <input type="checkbox" className="checkbox-Connectivity" />
                  </th>
                  {[
                    "ICCID",
                    "IMEI",
                    "VIN NUMBER",
                    "VEHICLE ID",
                    "CUSTOMER ID",
                    "ORDER ID",
                    "CARD STATE",
                    "CARD STATUS",
                    "ACTIVE PROFILES",
                    "ACTIVATION DATE",
                    "EXPIRY DATE",
                    "DATA USAGE",
                    "DATA USAGE DATE",
                    "FALLBACK STATUS",
                  ].map((h) => (
                    <th key={h} className="tableHeaderCell-Connectivity">
                      {h}
                      <i
                        className="fas fa-info-circle"
                        style={{
                          color: "#9ca3af",
                          marginLeft: "0.25rem",
                        }}
                      ></i>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {simData.map((sim, index) => (
                  <tr
                    key={sim.iccid || index}
                    className="tableRow-Connectivity"
                  >
                    <td className="tableCell-Connectivity">
                      <input
                        type="checkbox"
                        className="checkbox-Connectivity"
                        defaultChecked={sim.isChecked}
                      />
                    </td>
                    <td className="tableCell-Connectivity">{sim.iccid}</td>
                    <td className="tableCell-Connectivity">{sim.imei}</td>
                    <td className="tableCell-Connectivity">{sim.vin}</td>
                    <td className="tableCell-Connectivity">{sim.vehicle_id}</td>
                    <td className="tableCell-Connectivity">
                      {sim.customer_id}
                    </td>
                    <td className="tableCell-Connectivity">{sim.orderId}</td>
                    <td className="tableCell-Connectivity">{sim.cardState}</td>
                    <td className="tableCell-Connectivity">
                      {sim.primaryStatus}
                    </td>
                    <td className="tableCell-Connectivity">
                      {sim.active_profiles}
                    </td>
                    <td className="tableCell-Connectivity">
                      {sim.commercialActivationDate}
                    </td>
                    <td className="tableCell-Connectivity">
                      {sim.commercialExpiryDate}
                    </td>
                    <td className="tableCell-Connectivity">{sim.dataUsage}</td>
                    <td className="tableCell-Connectivity">
                      {sim.dataUsageDate}
                    </td>
                    <td className="tableCell-Connectivity">
                      {sim.fallBackStatus}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="ccoStatusContainer-Connectivity">
          <div className="ccoStatusHeader-Connectivity">
            <div>
              <h2 className="ccoStatusTitle-Connectivity">CCO Status</h2>
              <p className="ccoStatusSubtitle-Connectivity">
                View status of approved CCO requests
              </p>
            </div>

            <div className="ccoStatusActions-Connectivity">
              <div className="ccoDateFilter-Connectivity">
                <select
                  className="ccoDateSelect-Connectivity"
                  value={ccoDateRange}
                  onChange={(e) => handleCcoDateRangeChange(e.target.value)}
                  disabled={ccoStatusLoading}
                >
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last_week">Last Week</option>
                  <option value="custom">Custom</option>
                </select>
                <i className="fas fa-chevron-down ccoDateArrow-Connectivity"></i>
              </div>

              {ccoDateRange === "custom" && (
                <div className="ccoCustomDates-Connectivity">
                  <input
                    type="date"
                    className="ccoDateInput-Connectivity"
                    value={ccoStartDate}
                    onChange={(e) => {
                      setCcoStartDate(e.target.value);
                      setCcoStatusPage(1);
                      setCcoStatusError("");
                    }}
                    disabled={ccoStatusLoading}
                  />
                  <span className="ccoDateTo-Connectivity">to</span>
                  <input
                    type="date"
                    className="ccoDateInput-Connectivity"
                    value={ccoEndDate}
                    onChange={(e) => {
                      setCcoEndDate(e.target.value);
                      setCcoStatusPage(1);
                      setCcoStatusError("");
                    }}
                    disabled={ccoStatusLoading}
                  />
                </div>
              )}

              <button
                className="ccoStatusViewButton-Connectivity"
                onClick={() => {
                  setCcoStatusPage(1);
                  handleViewCcoStatus(1);
                }}
                disabled={ccoStatusLoading}
              >
                {ccoStatusLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="fas fa-eye"></i>
                    View
                  </>
                )}
              </button>
            </div>
          </div>

          {ccoStatusError && (
            <div className="ccoStatusError-Connectivity">
              <i className="fas fa-exclamation-circle"></i>
              {ccoStatusError}
            </div>
          )}

          {ccoStatusLoading ? (
            <div className="ccoStatusMessage-Connectivity">
              <i className="fas fa-spinner fa-spin"></i>
              <span>Loading CCO status...</span>
            </div>
          ) : ccoStatusData.length === 0 ? (
            <div className="ccoStatusMessage-Connectivity">
              <i className="fas fa-info-circle"></i>
              <span>No CCO status available for the selected date range.</span>
            </div>
          ) : (
            <>
              <div className="ccoStatusTableWrapper-Connectivity">
                <table className="table-Connectivity ccoStatusTable-Connectivity">
                  <thead className="tableHead-Connectivity">
                    <tr>
                      <th className="tableHeaderCell-Connectivity">SR ID</th>
                      <th className="tableHeaderCell-Connectivity">ICCID</th>
                      <th className="tableHeaderCell-Connectivity">ACTION</th>
                      <th className="tableHeaderCell-Connectivity">STATUS</th>
                      <th className="tableHeaderCell-Connectivity">
                        APPROVED DATE
                      </th>
                      <th className="tableHeaderCell-Connectivity">
                        APPROVED BY
                      </th>
                      <th className="tableHeaderCell-Connectivity">
                        CARD COUNT
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {ccoStatusData.map((item, index) => {
                      const iccids = Array.isArray(item.iccids)
                        ? item.iccids
                        : [];

                      return (
                        <tr
                          key={item.srid || index}
                          className="tableRow-Connectivity"
                        >
                          <td className="tableCell-Connectivity ccoSrIdCell-Connectivity">
                            {item.srid || "-"}
                          </td>
                          <td className="tableCell-Connectivity">
                            {iccids.length === 0 ? (
                              "-"
                            ) : iccids.length === 1 ? (
                              iccids[0]
                            ) : (
                              <button
                                className="rowRegister-Connectivity"
                                onClick={() => handleViewCcoIccids(item)}
                              >
                                <i
                                  className="fas fa-eye"
                                  style={{
                                    marginRight: "0.35rem",
                                  }}
                                ></i>
                                View All
                              </button>
                            )}
                          </td>
                          <td className="tableCell-Connectivity">
                            {item.actionRequested || "-"}
                          </td>
                          <td className="tableCell-Connectivity">
                            <span
                              className={`ccoStatusBadge-Connectivity ${String(
                                item.srStatus || "",
                              )
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`}
                            >
                              {item.srStatus || "-"}
                            </span>
                          </td>
                          <td className="tableCell-Connectivity">
                            {item.approvedDate || item.requestedDate || "-"}
                          </td>
                          <td className="tableCell-Connectivity">
                            {item.approvedBy || "-"}
                          </td>
                          <td className="tableCell-Connectivity">
                            {item.cardCount ?? "-"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="tablePagination-Connectivity">
                <div className="paginationInfo-Connectivity">
                  {ccoStatusTotalRecords === 0
                    ? "Items 0-0"
                    : `Items ${(ccoStatusPage - 1) * 5 + 1}-${Math.min(
                        ccoStatusPage * 5,
                        ccoStatusTotalRecords,
                      )} of ${ccoStatusTotalRecords}`}
                </div>

                <div className="paginationControls-Connectivity">
                  <button
                    className="paginationButton-Connectivity"
                    onClick={handleCcoStatusPreviousPage}
                    disabled={ccoStatusPage === 1 || ccoStatusLoading}
                  >
                    Prev
                  </button>

                  <button
                    className="paginationButton-Connectivity"
                    onClick={handleCcoStatusNextPage}
                    disabled={
                      ccoStatusPage >= ccoStatusTotalPages || ccoStatusLoading
                    }
                  >
                    Next
                  </button>

                  <div className="paginationSelect-Connectivity">
                    <select
                      className="paginationSelectField-Connectivity"
                      value="5"
                      disabled
                    >
                      <option value="5">5</option>
                    </select>
                    <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="ccoStatusContainer-Connectivity">
          <div className="ccoStatusHeader-Connectivity">
            <div>
              <h2 className="ccoStatusTitle-Connectivity">Ticket Status</h2>
              <p className="ccoStatusSubtitle-Connectivity">
                View status of raised Sensorise tickets
              </p>
            </div>

            <div className="ccoStatusActions-Connectivity">
              <div className="ccoDateFilter-Connectivity">
                <select
                  className="ccoDateSelect-Connectivity"
                  value={ticketDateRange}
                  onChange={(e) => handleTicketDateRangeChange(e.target.value)}
                  disabled={ticketStatusRequestsLoading}
                >
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last_week">Last Week</option>
                  <option value="custom">Custom</option>
                </select>
                <i className="fas fa-chevron-down ccoDateArrow-Connectivity"></i>
              </div>

              {ticketDateRange === "custom" && (
                <div className="ccoCustomDates-Connectivity">
                  <input
                    type="date"
                    className="ccoDateInput-Connectivity"
                    value={ticketStartDate}
                    onChange={(e) => {
                      setTicketStartDate(e.target.value);
                      setTicketStatusPage(1);
                      setTicketStatusRequestsError("");
                    }}
                    disabled={ticketStatusRequestsLoading}
                  />
                  <span className="ccoDateTo-Connectivity">to</span>
                  <input
                    type="date"
                    className="ccoDateInput-Connectivity"
                    value={ticketEndDate}
                    onChange={(e) => {
                      setTicketEndDate(e.target.value);
                      setTicketStatusPage(1);
                      setTicketStatusRequestsError("");
                    }}
                    disabled={ticketStatusRequestsLoading}
                  />
                </div>
              )}

              <button
                className="ccoStatusViewButton-Connectivity"
                onClick={() => {
                  setTicketStatusPage(1);
                  handleViewTicketStatusRequests(1);
                }}
                disabled={ticketStatusRequestsLoading}
              >
                {ticketStatusRequestsLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    Loading...
                  </>
                ) : (
                  <>
                    <i className="fas fa-eye"></i>
                    View
                  </>
                )}
              </button>
            </div>
          </div>

          {ticketStatusRequestsError && (
            <div className="ccoStatusError-Connectivity">
              <i className="fas fa-exclamation-circle"></i>
              {ticketStatusRequestsError}
            </div>
          )}

          {ticketStatusRequestsLoading ? (
            <div className="ccoStatusMessage-Connectivity">
              <i className="fas fa-spinner fa-spin"></i>
              <span>Loading ticket requests...</span>
            </div>
          ) : ticketStatusRequests.length === 0 ? (
            <div className="ccoStatusMessage-Connectivity">
              <i className="fas fa-info-circle"></i>
              <span>
                No ticket requests available for the selected date range.
              </span>
            </div>
          ) : (
            <>
              <div className="ccoStatusTableWrapper-Connectivity">
                <table className="table-Connectivity ccoStatusTable-Connectivity">
                  <thead className="tableHead-Connectivity">
                    <tr>
                      <th className="tableHeaderCell-Connectivity">
                        TICKET NO
                      </th>
                      <th className="tableHeaderCell-Connectivity">
                        FILE NAME
                      </th>
                      <th className="tableHeaderCell-Connectivity">
                        RAISED BY
                      </th>
                      <th className="tableHeaderCell-Connectivity">
                        RAISED AT
                      </th>
                      <th className="tableHeaderCell-Connectivity">ACTION</th>
                    </tr>
                  </thead>

                  <tbody>
                    {ticketStatusRequests.map((ticket, index) => (
                      <tr
                        key={ticket.id || ticket.ticketNo || index}
                        className="tableRow-Connectivity"
                      >
                        <td className="tableCell-Connectivity">
                          {ticket.ticketNo || "-"}
                        </td>
                        <td className="tableCell-Connectivity">
                          {ticket.fileName || "-"}
                        </td>
                        <td className="tableCell-Connectivity">
                          {ticket.raisedBy || "-"}
                        </td>
                        <td className="tableCell-Connectivity">
                          {ticket.raisedAt
                            ? new Date(ticket.raisedAt).toLocaleString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )
                            : "-"}
                        </td>
                        <td className="tableCell-Connectivity">
                          <button
                            className="rowRegister-Connectivity"
                            onClick={() =>
                              handleViewTicketStatus(ticket.ticketNo)
                            }
                            disabled={ticketStatusLoading}
                          >
                            <i
                              className="fas fa-eye"
                              style={{
                                marginRight: "0.35rem",
                              }}
                            ></i>
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="tablePagination-Connectivity">
                <div className="paginationInfo-Connectivity">
                  {ticketStatusTotalRecords === 0
                    ? "Items 0-0"
                    : `Items ${(ticketStatusPage - 1) * 5 + 1}-${Math.min(
                        ticketStatusPage * 5,
                        ticketStatusTotalRecords,
                      )} of ${ticketStatusTotalRecords}`}
                </div>

                <div className="paginationControls-Connectivity">
                  <button
                    className="paginationButton-Connectivity"
                    onClick={handleTicketStatusPreviousPage}
                    disabled={
                      ticketStatusPage === 1 || ticketStatusRequestsLoading
                    }
                  >
                    Prev
                  </button>

                  <button
                    className="paginationButton-Connectivity"
                    onClick={handleTicketStatusNextPage}
                    disabled={
                      ticketStatusPage >= ticketStatusTotalPages ||
                      ticketStatusRequestsLoading
                    }
                  >
                    Next
                  </button>

                  <div className="paginationSelect-Connectivity">
                    <select
                      className="paginationSelectField-Connectivity"
                      value="5"
                      disabled
                    >
                      <option value="5">5</option>
                    </select>
                    <i className="fas fa-chevron-down paginationSelectIcon-Connectivity"></i>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="connectivityChartsRow-Connectivity">
          <div className="card-Connectivity connectivityChartCard-Connectivity">
            <div className="connectivityChartHeader-Connectivity">
              <div>
                <h2 className="simStatusTitle-Connectivity">SIM statuses</h2>
                <p className="connectivityChartSubtitle-Connectivity">
                  Current SIM status distribution
                </p>
              </div>

              <div className="totalIccidBadge-Connectivity">
                <i className="fas fa-sim-card"></i>
                <span>{totalIccidCount.toLocaleString()}</span>
                <small>Total ICCIDs</small>
              </div>
            </div>

            <div className="simStatusContent-Connectivity">
              <div className="chartContainer-Connectivity simStatusChartWrapper-Connectivity">
                <canvas ref={simStatusChartRef}></canvas>
                <div className="simStatusCenterValue-Connectivity">
                  <strong>{totalIccidCount.toLocaleString()}</strong>
                  <span>Total ICCIDs</span>
                </div>
              </div>

              <div className="legendContainer-Connectivity">
                {simStatusData.labels.map((label, index) => (
                  <div key={label} className="legendItem-Connectivity">
                    <div
                      className="legendColor-Connectivity"
                      style={{
                        backgroundColor: simStatusData.colors[index],
                      }}
                    ></div>
                    <span>{label}</span>
                    <span className="legendCount-Connectivity">
                      {simStatusData.counts[index].toLocaleString()}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="card-Connectivity connectivityChartCard-Connectivity">
            <div className="connectivityChartHeader-Connectivity">
              <div>
                <h2 className="simStatusTitle-Connectivity">
                  Monthly usage (MB)
                </h2>
                <p className="connectivityChartSubtitle-Connectivity">
                  Monthly data usage by plan
                </p>
              </div>
            </div>

            <div className="usageChartContainer-Connectivity">
              <canvas ref={monthlyUsageChartRef}></canvas>
            </div>
          </div>
        </div>
      </div>

      {ccoIccidModal && (
        <div
          className="ticketStatusOverlay-Connectivity"
          onClick={handleCloseCcoIccidModal}
        >
          <div
            className="ticketStatusModal-Connectivity"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ticketStatusModalHeader-Connectivity">
              <div>
                <h2 className="ticketStatusModalTitle-Connectivity">
                  ICCID Details
                </h2>
                <p className="ticketStatusModalSubtitle-Connectivity">
                  ICCIDs associated with SR ID {selectedCcoSrId || "-"}
                </p>
              </div>

              <button
                className="ticketStatusModalClose-Connectivity"
                onClick={handleCloseCcoIccidModal}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="ticketStatusDetails-Connectivity">
              <div className="ticketStatusDetailGrid-Connectivity">
                <div className="ticketStatusDetailItem-Connectivity">
                  <span className="ticketStatusDetailLabel-Connectivity">
                    SR ID
                  </span>
                  <span className="ticketStatusDetailValue-Connectivity">
                    {selectedCcoSrId || "-"}
                  </span>
                </div>

                <div className="ticketStatusDetailItem-Connectivity">
                  <span className="ticketStatusDetailLabel-Connectivity">
                    ICCID Count
                  </span>
                  <span className="ticketStatusDetailValue-Connectivity">
                    {selectedCcoIccids.length}
                  </span>
                </div>
              </div>

              <div className="ticketStatusResponseBox-Connectivity">
                <span className="ticketStatusDetailLabel-Connectivity">
                  ICCIDs
                </span>

                <div
                  style={{
                    marginTop: "0.75rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                  }}
                >
                  {selectedCcoIccids.length > 0 ? (
                    selectedCcoIccids.map((iccid, index) => (
                      <div
                        key={`${iccid}-${index}`}
                        style={{
                          padding: "0.65rem 0.75rem",
                          border: "1px solid #e5e7eb",
                          borderRadius: "6px",
                          backgroundColor: "#f9fafb",
                          fontSize: "0.9rem",
                          color: "#374151",
                        }}
                      >
                        {iccid}
                      </div>
                    ))
                  ) : (
                    <p>-</p>
                  )}
                </div>
              </div>
            </div>

            <div className="ticketStatusModalFooter-Connectivity">
              <button
                className="buttonSecondary-Connectivity"
                onClick={handleCloseCcoIccidModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {ticketStatusModal && (
        <div
          className="ticketStatusOverlay-Connectivity"
          onClick={handleCloseTicketStatus}
        >
          <div
            className="ticketStatusModal-Connectivity"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ticketStatusModalHeader-Connectivity">
              <div>
                <h2 className="ticketStatusModalTitle-Connectivity">
                  Ticket Status Details
                </h2>
                <p className="ticketStatusModalSubtitle-Connectivity">
                  Sensorise ticket information
                </p>
              </div>

              <button
                className="ticketStatusModalClose-Connectivity"
                onClick={handleCloseTicketStatus}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {ticketStatusLoading ? (
              <div className="ticketStatusModalMessage-Connectivity">
                <i className="fas fa-spinner fa-spin"></i>
                <span>Fetching ticket status...</span>
              </div>
            ) : ticketStatusError ? (
              <div className="ticketStatusModalError-Connectivity">
                <i className="fas fa-exclamation-circle"></i>
                <span>{ticketStatusError}</span>
              </div>
            ) : ticketStatusData ? (
              <div className="ticketStatusDetails-Connectivity">
                <div className="ticketStatusDetailGrid-Connectivity">
                  <div className="ticketStatusDetailItem-Connectivity">
                    <span className="ticketStatusDetailLabel-Connectivity">
                      Ticket No
                    </span>
                    <span className="ticketStatusDetailValue-Connectivity">
                      {ticketStatusData.ticketNo || "-"}
                    </span>
                  </div>

                  <div className="ticketStatusDetailItem-Connectivity">
                    <span className="ticketStatusDetailLabel-Connectivity">
                      Status
                    </span>
                    <span
                      className={`ticketStatusBadge-Connectivity ${String(
                        ticketStatusData.status || "",
                      )
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {ticketStatusData.status || "-"}
                    </span>
                  </div>

                  <div className="ticketStatusDetailItem-Connectivity">
                    <span className="ticketStatusDetailLabel-Connectivity">
                      Raised By
                    </span>
                    <span className="ticketStatusDetailValue-Connectivity">
                      {ticketStatusData.raisedBy || "-"}
                    </span>
                  </div>

                  <div className="ticketStatusDetailItem-Connectivity">
                    <span className="ticketStatusDetailLabel-Connectivity">
                      Raised At
                    </span>
                    <span className="ticketStatusDetailValue-Connectivity">
                      {ticketStatusData.raisedAt
                        ? new Date(ticketStatusData.raisedAt).toLocaleString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )
                        : "-"}
                    </span>
                  </div>

                  <div className="ticketStatusDetailItem-Connectivity">
                    <span className="ticketStatusDetailLabel-Connectivity">
                      Response Code
                    </span>
                    <span className="ticketStatusDetailValue-Connectivity">
                      {ticketStatusData.apiResponseCode || "-"}
                    </span>
                  </div>
                </div>

                <div className="ticketStatusResponseBox-Connectivity">
                  <span className="ticketStatusDetailLabel-Connectivity">
                    Response Message
                  </span>
                  <p>{ticketStatusData.apiResponseMsg || "-"}</p>
                </div>

                <div className="ticketStatusRemarkBox-Connectivity">
                  <span className="ticketStatusDetailLabel-Connectivity">
                    Remark
                  </span>
                  <p>{ticketStatusData.apiResponseRemark || "-"}</p>
                </div>
              </div>
            ) : (
              <div className="ticketStatusModalMessage-Connectivity">
                <i className="fas fa-info-circle"></i>
                <span>No ticket status information available.</span>
              </div>
            )}

            <div className="ticketStatusModalFooter-Connectivity">
              <button
                className="buttonSecondary-Connectivity"
                onClick={handleCloseTicketStatus}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ConnectivityDashboard;
